export default {
  'pages.accounting.salaryManagement.settlement.proration': '工作日精算',
  'pages.accounting.salaryManagement.settlement.prorationHelp':
    '仅基本给按{days}/{total}个工作日精算：{amount}。公司保险负担保持正常月额。',
  'pages.accounting.salaryManagement.settlement.compensation': '额外补偿',
  'pages.accounting.salaryManagement.settlement.compensationHelp':
    '正常成本之外，本月一次性计入补偿{amount}。不会生成其他月份工资或实际付款记录。',
  'pages.accounting.salaryManagement.settlement.monthlyBase': '原月额基本给：{amount}',
  'pages.accounting.salaryManagement.settlement.reviewHelp':
    '入离职日期与已确认的个别精算条件不同，请核对工资和成本。',
  'pages.interviewList.simple.basic': '基本信息',
  'pages.interviewList.simple.gender': '性别',
  'pages.interviewList.simple.birthday': '出生日期',
  'pages.interviewList.simple.age': '{age}岁',
  'pages.interviewList.simple.country': '国籍',
  'pages.interviewList.simple.region': '省份／地区',
  'pages.interviewList.simple.visa': '在留信息',
  'pages.interviewList.simple.visaExpiry': '在留有效期',
  'pages.interviewList.simple.remainingDays': '剩余 {days} 天',
  'pages.interviewList.simple.screening': '履历筛选',
  'pages.interviewList.simple.screeningResult': '筛选结果',
  'pages.interviewList.simple.screeningRemarks': '筛选备注',
  'pages.interviewList.simple.first': '一次面试',
  'pages.interviewList.simple.interviewer': '面试担当',
  'pages.interviewList.simple.interviewStatus': '实施状态',
  'pages.interviewList.simple.skill': '经验技能',
  'pages.interviewList.simple.communication': '沟通能力',
  'pages.interviewList.simple.thinking': '主动性／思考力',
  'pages.interviewList.simple.personality': '人物适性',
  'pages.interviewList.simple.motivation': '志望动机',
  'pages.interviewList.simple.japanese': '日语能力',
  'pages.interviewList.simple.scoreGuide': '评分标准',
  'pages.interviewList.simple.evaluation': '面试评价',
  'pages.interviewList.simple.rollback': '退回履历筛选（清除一面信息）',
  'pages.interviewList.simple.training': '研修',
  'pages.interviewList.simple.trainingHint':
    '人事只登记开始日期。研修期间、测试及评价由开发部管理。',
  'pages.interviewList.simple.trainingStart': '研修开始日期',
  'pages.interviewList.simple.developmentManaged': '开发部已接手，请在进度日历中修改开始日期。',
  'pages.interviewList.simple.followup': '开发部后续跟进（只读）',
  'pages.interviewList.simple.trainingEnd': '研修结束日期',
  'pages.interviewList.simple.trainingStatus': '研修状态',
  'pages.interviewList.simple.testDate': '测试日期',
  'pages.interviewList.simple.testResult': '测试结果',
  'pages.interviewList.simple.trainingRemarks': '研修备注',
  'pages.interviewList.simple.accountStatus': '账号状态',
  'pages.interviewList.simple.active': '使用中',
  'pages.interviewList.simple.inactive': '停用',
  'pages.interviewList.simple.accountNotCreated': '未生成',
  'pages.interviewList.simple.pendingTrainings': '人事登记・待安排研修',
  'pages.interviewList.simple.arrangeTraining': '安排',
  'pages.interviewList.simple.waitingAccount': '等待人事生成账号',
  'pages.interviewList.simple.completePeriod': '请正确填写开始和结束日期。',
  'pages.interviewList.simple.status.not_started': '未实施',
  'pages.interviewList.simple.status.completed': '已实施',
  'pages.interviewList.simple.status.declined': '辞退',
  'pages.interviewList.simple.status.absent': '无故缺席',
  'pages.development.frontendStage': '阶段1：前端学习',
  'pages.development.backendStage': '阶段2：后端学习',
  'pages.development.backendProgressStage': '阶段2：后端学习（SQL・Java）',
  'pages.development.displayName': '展示名称',
  'pages.development.sourceName': '原始名称（视频与数据关联用）',
  'pages.development.stageFilter': '学习阶段',
  'pages.development.topicFilter': '学习主题',
  'pages.accountManagement.delete.departureRequired':
    '契约员工、正式员工停用前，请先在员工信息中填写离职日期。',
  'pages.accountManagement.restore': '恢复',
  'pages.accountManagement.restore.confirmTitle': '确定恢复账号吗？',
  'pages.accountManagement.restore.confirmDescription':
    '将恢复“{accountName}”的登录，保留的角色权限和关联信息将重新生效，不修改离职信息。历史已删除的角色需单独重新配置。',
  'pages.accountManagement.restore.done':
    '账号已恢复，保留的角色权限和关联信息已重新生效。历史已删除的角色需重新配置。',
  'pages.accountManagement.restore.failed': '账号恢复失败。',
  'pages.accounting.salaryManagement.historicalMonth': '历史月份仅供查看。',
  'pages.accounting.salaryManagement.contractType.management': '正式员工・管理',
  'pages.accounting.salaryManagement.cost.fixedHelp':
    '案件收入为0，经营管理用总成本固定为10万日元。实际工资和保险明细不变。',
  'pages.accounting.dashboard.fixedCost.note':
    '普通员工案件收入为0时，每月经营成本按10万日元计算；管理人员及已确认的社内员工除外。个别精算和补偿单独显示，总成本可能与工资及保险明细合计不同。',
  'pages.accounting.dashboard.warning.payrollDetail':
    '工资或保险明细存在待确认资料；适用固定成本的人员仍可计算利润。',
  'pages.layouts.userLayout.title': '我们不只是写代码，我们在调试未来',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.accountName.placeholder': '用户名:',
  'pages.login.accountName.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码:',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 账号管理页面
  'pages.roleManagement.selectedDelete': '角色名称',
  'pages.roleManagement.roleDescription': '角色说明',
  'pages.roleManagement.operation': '操作',
  'pages.roleManagement.roleList': '角色列表',
  'pages.roleManagement.createRole': '创建角色',
  'pages.roleManagement.updateRole': '更新角色',
  'pages.roleManagement.ruleNameIsRequired': '角色名称为必填项',

  // 画面权限管理
  'pages.pageAuthManagement.pageId': '页面ID',
  'pages.pageAuthManagement.pageName': '页面名称',
  'pages.pageAuthManagement.description': '页面说明',
  'pages.pageAuthManagement.operation': '操作',
  'pages.pageAuthManagement.auth': '权限编辑',
  'pages.pageAuthManagement.update': '设置',
  'pages.pageAuthManagement.serachList': '搜索结果',
  'pages.pageAuthManagement.searchList': '搜索结果',
  'pages.pageAuthManagement.title': '页面权限管理',
  'pages.pageAuthManagement.search.button': '搜索',
  'pages.pageAuthManagement.search.placeholder': '按页面ID / 页面名称 / 页面说明搜索',
  'pages.pageAuthManagement.search.result': '搜索结果',
  'pages.pageAuthManagement.search.countUnit': '件',
  'pages.pageAuthManagement.reload': '重新加载',
  'pages.pageAuthManagement.filter.keyword': '搜索',
  'pages.pageAuthManagement.filter.all': '全部',
  'pages.pageAuthManagement.filter.department': '部门',
  'pages.pageAuthManagement.department.all': '全部',
  'pages.pageAuthManagement.department.humanResources': '人事部',
  'pages.pageAuthManagement.department.development': '开发部',
  'pages.pageAuthManagement.department.generalAffairs': '总务部',
  'pages.pageAuthManagement.department.sales': '营业部',
  'pages.pageAuthManagement.department.accounting': '经理部',
  'pages.pageAuthManagement.department.systemSettings': '系统设置',
  'pages.pageAuthManagement.department.common': '共通',
  'pages.pageAuthManagement.permissionSummary.title': '权限概要',
  'pages.pageAuthManagement.permissionSummary.expandHint': '展开后确认',
  'pages.pageAuthManagement.permissionSummary.loading': '读取中',
  'pages.pageAuthManagement.permissionSummary.loaded': '{operationCount}个权限 / {roleCount}个角色',
  'pages.pageAuthManagement.permissionSummary.empty': '没有权限信息。',
  'pages.pageAuthManagement.permissionSummary.unset': '未设置',
  'pages.pageAuthManagement.load.failed': '页面列表获取失败。',
  'pages.pageAuthManagement.auth.loadFailed': '页面权限信息获取失败。',
  'pages.pageAuthManagement.modal.title': '页面权限编辑',
  'pages.pageAuthManagement.modal.operationCount': '操作数',
  'pages.pageAuthManagement.modal.selectedRoleCount': '已选择',
  'pages.pageAuthManagement.modal.readonly': '当前账号没有更新权限，仅可查看。',
  'pages.pageAuthManagement.action.save': '保存',
  'pages.pageAuthManagement.action.cancel': '取消',
  'pages.pageAuthManagement.action.saveAnyway': '继续保存',
  'pages.pageAuthManagement.emptyRole.confirmTitle': '存在未设置角色的操作。',
  'pages.pageAuthManagement.emptyRole.confirmDescription':
    '以下操作不会分配给任何角色。确定继续保存吗？',
  'pages.pageAuthManagement.update.process': '正在更新页面权限...',
  'pages.pageAuthManagement.update.done': '页面权限已更新。',
  'pages.pageAuthManagement.update.failed': '页面权限更新失败。',

  // Dashboard
  'pages.dashboard.title': '人事数据控制中心',
  'pages.dashboard.subtitle': '实时监测在职员工状态、临近更新在留资格和待办事务',
  'pages.dashboard.refresh': '更新',
  'pages.dashboard.quickAccess': '快捷入口',
  'pages.dashboard.traineeList': '研修信息一览',
  'pages.dashboard.regularList': '员工信息一览',
  'pages.dashboard.bpList': 'BP信息一览',
  'pages.dashboard.distribution': '员工构成比例',
  'pages.dashboard.distribution.regular': '正社员 / 契约',
  'pages.dashboard.distribution.trainee': '在籍 / 在校研修生',
  'pages.dashboard.distribution.bp': '业务合作伙伴 (BP)',
  'pages.dashboard.historyTitle': '离学/离职历史汇总',
  'pages.dashboard.history.dropout': '退学研修生',
  'pages.dashboard.history.resigned': '退职正社员',
  'pages.dashboard.history.bpFinished': 'BP项目结项',
  'pages.dashboard.empty.title': '工作已经全部处理完毕！🎉',
  'pages.dashboard.empty.description': '当前没有任何临期在留资格更新、待安排面试或到期合同。',
  'pages.dashboard.visaRenewalDesc': '临近 90 天到期，需要尽快协助社员办理续签手续',
  'pages.dashboard.traineeVisaRenewalDesc': '在籍或在校研修生在留期限到期提示，需提报审核材料',
  'pages.dashboard.interviewWaitDesc': '契约社员合同即将到期，需安排转正跟进面谈',
  'pages.dashboard.contractWaitDesc': '契约与正社员合同到期前沟通，意向确认与签约手续处理',
  'pages.dashboard.total': '合计',
  'pages.dashboard.viewAll': '显示全部 →',
  'pages.dashboard.activeStatus': '在籍状况',
  'pages.dashboard.totalActive': '在籍总数',
  'pages.dashboard.trainee': '就业导向',
  'pages.dashboard.regular': '员工',
  'pages.dashboard.bp': 'BP员工',
  'pages.dashboard.terminated': '关系结束者',
  'pages.dashboard.dropout': '研修离脱',
  'pages.dashboard.resigned': '退职',
  'pages.dashboard.bpFinished': 'BP结束',
  'pages.dashboard.actionRequired': '要对应',
  'pages.dashboard.actionRequiredWorkplace': '待处理事务工作台',
  'pages.dashboard.actionRequiredDesc': '需要立即核实处理',
  'pages.dashboard.noActionRequired': '所有事务已处理完毕',
  'pages.dashboard.visaRenewal': '在留更新（90日以内）',
  'pages.dashboard.interviewWait': '转正面谈待定',
  'pages.dashboard.contractWait': '合同切换待定',
  'pages.dashboard.birthdayThisMonth': '本月生日',
  'pages.dashboard.birthdayDesc': '本月社员生日会 🍰',
  'pages.dashboard.noBirthdayDesc': '本月无生日社员',
  'pages.dashboard.traineeVisaRenewal': '在留资格变更・更新',
  'pages.dashboard.pendingAlertTitle': '业务状态提示',
  'pages.dashboard.people': '人',
  'pages.dashboard.msg.loadFailed': '仪表盘数据加载失败。',
  'pages.dashboard.recruitmentPipeline': '招聘与选考看板',
  'pages.dashboard.upcomingInterviews': '近期面试日程',
  'pages.dashboard.pipeline.screening': '简历筛选中',
  'pages.dashboard.pipeline.scheduled': '面试待实施',
  'pages.dashboard.pipeline.testing': '测试中/结果待定',
  'pages.dashboard.pipeline.pending': '决策待定中',
  'pages.dashboard.interviews.empty': '近期无面试安排',
  'pages.dashboard.card.interview': '面试信息一览',
  'pages.dashboard.card.trainee': '研修信息一览',
  'pages.dashboard.card.regular': '员工信息一览',
  'pages.dashboard.card.bp': 'BP信息一览',
  'pages.dashboard.card.pending': '未定信息一览',
  'pages.dashboard.undefinedAccounts': '未定人员账户名列表',
  'pages.dashboard.noUndefinedAccounts': '暂无未定人员',
  'pages.dashboard.accountStatus.disabled': '停用',
  'pages.dashboard.accountStatus.active': '正在使用',
  'pages.dashboard.viewAllUndefined': '前往未定信息列表管理 →',
  'pages.dashboard.undefinedMore': '还有 {count} 件未显示，请进入列表查看。',
  'pages.dashboard.bpFinishedTitle': '历史结项',

  // 员工列表管理
  'pages.employeeList.title': '员工列表',
  'pages.employeeList.trainee.title': '研修情報一覧',
  'pages.employeeList.regular.title': '社員情報一覧',
  'pages.employeeList.bp.title': 'BP社員情報一覧',
  'pages.employeeList.employeeNo': '社员ID',
  'pages.employeeList.fullNameKanji': '社员名',
  'pages.employeeList.accountName': '账户名',
  'pages.employeeList.division': '事业部',
  'pages.employeeList.department': '部门',
  'pages.employeeList.position': '职位',
  'pages.employeeList.contractType': '所属形态',
  'pages.employeeList.contractType.bpActiveTitle': '【契约中】',
  'pages.employeeList.joiningCompanyDate': '入职日期',
  'pages.employeeList.contractPeriodFrom': '合同期间（开始）',
  'pages.employeeList.contractPeriodTo': '合同期间（结束）',
  'pages.employeeList.phone': '电话号码',
  'pages.employeeList.mailAddress': '邮箱',
  'pages.employeeList.status': '状态',
  'pages.employeeList.status.undefined': '未定',
  'pages.employeeList.operation': '操作',
  'pages.employeeList.update': '更新',
  'pages.employeeList.all': '全部',
  'pages.employeeList.total': '合计',
  'pages.employeeList.reload': '重新加载',
  'pages.employeeList.terminationType': '关系终止者信息',
  'pages.employeeList.terminationType.bpFinishedTitle': '【契约结束】',
  'pages.employeeList.terminationType.dropout': '研修脱离',
  'pages.employeeList.terminationType.resigned': '退職',
  'pages.employeeList.terminationType.bpFinished': 'BP结束',
  'pages.employeeList.allActive': '全部（在职）',
  'pages.employeeList.allTerminated': '全部（关系终止者）',
  'pages.employeeList.regularConfirmStatus': '转正确认状态',
  'pages.employeeList.regularConfirmStatus.unconfirmed': '未确认',
  'pages.employeeList.regularConfirmStatus.confirmed': '确认OK',
  'pages.employeeList.regularConfirmStatus.rejected': '延期',
  'pages.employeeList.actionRequired': '待处理',
  'pages.employeeList.actionRequired.all': '待处理',
  'pages.employeeList.actionRequired.birthdayLastMonth': '上月生日',
  'pages.employeeList.actionRequired.birthdayThisMonth': '当月生日',
  'pages.employeeList.actionRequired.birthdayNextMonth': '下月生日',
  'pages.employeeList.actionRequired.visaRenewal90Days': '在留更新对象（90日以内）',
  'pages.employeeList.actionRequired.regularInterviewWait': '正式员工面谈等待',
  'pages.employeeList.actionRequired.regularContractWait': '正式员工合同切换等待',
  'pages.employeeList.actionRequired.traineeVisaRenewal':
    '在留变更・更新对象（研修社員（内定者））',

  // 社員一覧管理 - 筛选标签
  'pages.employeeList.gender': '性别',
  'pages.employeeList.birthday': '出生日期',
  'pages.employeeList.age': '年龄',
  'pages.employeeList.yearsOfService': '工龄',
  'pages.employeeList.visaCardNo': '在留卡号码',
  'pages.employeeList.visaType': '在留资格',
  'pages.employeeList.visaValidTo': '有效期限',
  'pages.employeeList.remainingDays': '剩余天数',
  'pages.employeeList.individualNumber': '个人编号',
  'pages.employeeList.bankAccount': '工资账户',
  'pages.employeeList.address': '住址',
  'pages.employeeList.remarks': '备注',

  // 社員一覧管理 - 性别
  'pages.employeeList.gender.unset': '未设置',
  'pages.employeeList.gender.male': '男性',
  'pages.employeeList.gender.female': '女性',
  'pages.employeeList.gender.other': '其他',

  // 社員一覧管理 - 部门
  'pages.employeeList.department.dev1': '开发一部',
  'pages.employeeList.department.dev2': '开发二部',
  'pages.employeeList.department.accounting': '会计部',
  'pages.employeeList.department.hr': '人事部',
  'pages.employeeList.department.sales': '营业部',
  'pages.employeeList.department.ga': '总务部',
  'pages.employeeList.department.it': '信息系统部',
  'pages.employeeList.department.bp': 'BP员工',

  // 社員一覧管理 - 职位
  'pages.employeeList.position.member': '部员',
  'pages.employeeList.position.chief': '系长',
  'pages.employeeList.position.manager': '课长',
  'pages.employeeList.position.director': '部长',

  // 社員一覧管理 - 所属形态
  'pages.employeeList.contractType.trainee': '就业导向',
  'pages.employeeList.contractType.internal': '研修社员（内定者）',
  'pages.employeeList.contractType.contract': '契约社员',
  'pages.employeeList.contractType.regular': '正社员',
  'pages.employeeList.contractType.bp': 'BP社员',
  'pages.employeeList.contractType.bpStudy': 'BP社员在学',
  'pages.employeeList.contractType.bpEnrolled': 'BP社员在籍',

  // 社員一覧管理 - 编辑弹窗
  'pages.employeeList.edit.title': '编辑员工信息',
  'pages.employeeList.edit.personalInfo': '个人信息',
  'pages.employeeList.edit.visaInfo': '在留信息',
  'pages.employeeList.edit.employmentInfo': '雇佣信息',
  'pages.employeeList.edit.bankInfo': '银行账户',
  'pages.employeeList.edit.basicInfo': '基本个人信息',
  'pages.employeeList.edit.contactInfo': '联系方式',
  'pages.employeeList.edit.contractInfo': '契约信息',
  'pages.employeeList.edit.orgInfo': '组织・期间信息',
  'pages.employeeList.edit.visaCardInfo': '在留卡信息',
  'pages.employeeList.edit.bankAccountInfo': '银行账户信息',
  'pages.employeeList.edit.remarksInfo': '备注栏',

  // 表单字段标签
  'pages.employeeList.field.firstNameKanji': '姓(汉字)',
  'pages.employeeList.field.lastNameKanji': '名(汉字)',
  'pages.employeeList.field.firstNameKana': '姓(片假名)',
  'pages.employeeList.field.lastNameKana': '名(片假名)',
  'pages.employeeList.field.firstNameRoma': '姓(罗马字)',
  'pages.employeeList.field.lastNameRoma': '名(罗马字)',
  'pages.employeeList.field.gender': '性别',
  'pages.employeeList.field.birthday': '出生日期',
  'pages.employeeList.field.nationality': '国籍',
  'pages.employeeList.field.phone': '电话号码',
  'pages.employeeList.field.mobile': '手机号码',
  'pages.employeeList.field.postalCode': '邮编',
  'pages.employeeList.field.mailAddress': '邮箱地址',
  'pages.employeeList.field.address': '住址',
  'pages.employeeList.field.visaCardNo': '在留卡号码',
  'pages.employeeList.field.visaType': '在留资格',
  'pages.employeeList.field.visaValidTo': '卡片期限',
  'pages.employeeList.field.visaFromDate': '在留期间(开始)',
  'pages.employeeList.field.visaToDate': '在留期间(结束)',
  'pages.employeeList.field.individualNumber': '个人编号',
  'pages.employeeList.field.accountId': '账户ID',
  'pages.employeeList.field.division': '事业部',
  'pages.employeeList.field.contractType': '所属形态',
  'pages.employeeList.field.regularConfirmStatus': '转正确认',
  'pages.employeeList.field.department': '部门',
  'pages.employeeList.field.position': '职位',
  'pages.employeeList.field.joiningDate': '入职日',
  'pages.employeeList.field.departureDate': '退职日',
  'pages.employeeList.field.contractPeriodFrom': '契约期间(开始)',
  'pages.employeeList.field.contractPeriodTo': '契约期间(结束)',
  'pages.employeeList.field.employmentInsuranceNo': '雇佣保险',
  'pages.employeeList.field.healthInsurerNo': '保险者号码',
  'pages.employeeList.field.healthInsuranceSymbol': '被保险者证记号',
  'pages.employeeList.field.healthInsuranceNo': '被保险者证号码',
  'pages.employeeList.healthInsurance.help':
    '三项可以全部留空；填写任意一项时，必须将三项全部填写完整。',
  'pages.employeeList.healthInsurance.incomplete':
    '填写健康保险信息时，请完整填写保险者号码、被保险者证记号和被保险者证号码。',
  'pages.employeeList.healthInsurance.digitsOnly': '只能输入数字。',
  'pages.employeeList.healthInsurance.maxLength': '请输入30位以内的数字。',
  'pages.employeeList.field.bankName': '银行名',
  'pages.employeeList.field.bankBranch': '支行名',
  'pages.employeeList.field.bankAccountType': '账户类型',
  'pages.employeeList.field.bankAccountNo': '账户号码',
  'pages.employeeList.field.bankAccountHolder': '账户名义',
  'pages.employeeList.field.remarks': '备注',

  // 表单选项值
  'pages.employeeList.option.nationality.china': '中国',
  'pages.employeeList.option.nationality.japan': '日本',
  'pages.employeeList.option.nationality.other': '其他',
  'pages.employeeList.option.division.hq': '本部',
  'pages.employeeList.option.division.ec': 'EC',
  'pages.employeeList.option.regularConfirm.unconfirmed': '未确认',
  'pages.employeeList.option.regularConfirm.confirmed': '确认OK',
  'pages.employeeList.option.regularConfirm.rejected': '延期',
  'pages.employeeList.option.accountType.normal': '普通',
  'pages.employeeList.option.accountType.current': '当座',
  'pages.employeeList.option.accountType.savings': '储蓄',

  // 在留資格选项
  'pages.employeeList.visaType.unset': '未设置',
  'pages.employeeList.visaType.engineer': '技术・人文知识・国际业务',
  'pages.employeeList.visaType.highlySkilled1': '高度专门职1号',
  'pages.employeeList.visaType.highlySkilled2': '高度专门职2号',
  'pages.employeeList.visaType.business': '经营・管理',
  'pages.employeeList.visaType.intraCompany': '企业内部调动',
  'pages.employeeList.visaType.permanent': '永住者',
  'pages.employeeList.visaType.other': '其他',

  // 按钮和消息
  'pages.employeeList.btn.cancel': '取消',
  'pages.employeeList.btn.save': '保存',
  'pages.employeeList.btn.edit': '编辑',
  'pages.employeeList.msg.loading': '重新加载中...',
  'pages.employeeList.msg.reloadSuccess': '更新完成',
  'pages.employeeList.msg.searchFailed': '搜索失败。',
  'pages.employeeList.msg.fetchFailed': '获取员工信息失败。',
  'pages.employeeList.msg.saveSuccess': '保存成功。',
  'pages.employeeList.msg.saveFailed': '保存失败。',

  // 时间单位
  'pages.employeeList.unit.year': '年',
  'pages.employeeList.unit.month': '个月',
  'pages.employeeList.unit.day': '天',
  'pages.employeeList.status.expired': '已过期',

  'pages.development.learnManagement.course.qaAnswerDeleted': '小课程QA回答已删除',
  'pages.development.learnManagement.course.qaAnswerDeleteFailed': '删除失败',
  'pages.development.learnManagement.course.qaAnswerUpdated': '小课程QA回答已更新',
  'pages.development.learnManagement.course.qaAnswerAdded': '小课程QA回答已添加',
  'pages.development.learnManagement.course.questionId': '问题ID',
  'pages.development.learnManagement.course.accountId': '账户ID',
  'pages.development.learnManagement.course.answerResult': '回答结果',
  'pages.development.learnManagement.course.answerCorrect': '正确',
  'pages.development.learnManagement.course.answerIncorrect': '错误',
  'pages.development.learnManagement.course.score': '成绩',
  'pages.development.learnManagement.course.editAnswer': '编辑回答',
  'pages.development.learnManagement.course.smallCourseQuestionId': '小课程问题ID',
  'pages.development.learnManagement.course.smallCourseQuestionIdRequired': '请输入小课程问题ID',
  'pages.development.learnManagement.course.accountIdRequired': '请输入账户ID',
  'pages.development.learnManagement.course.answerContentLabel': '回答内容 (A/B/C/D)',
  'pages.development.learnManagement.course.answerContentPattern': '请输入 A, B, C, D',
  'pages.development.learnManagement.course.answerContentPlaceholder': '用户选择的答案 (A/B/C/D)',
  'pages.development.learnManagement.course.answerResultPlaceholder':
    '输入回答结果 (0=错误, 1=正确)',
  'pages.development.learnManagement.course.scorePlaceholder': '输入成绩',

  // 学习管理 - 播放器页面
  'pages.learnPlayer.home': '首页',
  'pages.learnPlayer.course': '课程',
  'pages.learnPlayer.downloadMaterials': '下载材料',
  'pages.learnPlayer.backToHome': '返回首页',
  'pages.learnPlayer.menuArea': '菜单区域',
  'pages.learnPlayer.testPage': '前往测试页面',
  'pages.learnPlayer.download': '下载',
  'pages.learnPlayer.playlist': '播放列表',
  'pages.learnPlayer.currentPlaying': '当前播放',
  'pages.learnPlayer.questionSubmit': '问题提交',
  'pages.learnPlayer.title': '标题',
  'pages.learnPlayer.titlePlaceholder': '请输入问题标题（5-30字符）',
  'pages.learnPlayer.titleRequired': '请输入标题',
  'pages.learnPlayer.titleMin': '标题至少5个字符',
  'pages.learnPlayer.titleMax': '标题最多30个字符',
  'pages.learnPlayer.content': '内容',
  'pages.learnPlayer.contentPlaceholder': '请输入问题内容（10-20000字符）',
  'pages.learnPlayer.contentRequired': '请输入问题内容',
  'pages.learnPlayer.contentMin': '内容至少10个字符',
  'pages.learnPlayer.contentMax': '内容最多20000个字符',
  'pages.learnPlayer.attachments': '附件',
  'pages.learnPlayer.uploadFile': '上传文件',
  'pages.learnPlayer.submit': '提交',
  'pages.learnPlayer.submitSuccess': '问题提交成功',
  'pages.learnPlayer.qa': 'Q&A',
  'pages.learnPlayer.noQuestions': '暂无问题',
  'pages.learnPlayer.resolved': '已解决',
  'pages.learnPlayer.unresolved': '未解决',
  'pages.learnPlayer.getCourseInfoFailed': '获取课程信息失败',
  'pages.learnPlayer.getQuestionsFailed': '获取问题列表失败',
  'pages.learnPlayer.submitQuestionFailed': '问题提交失败',
  'pages.learnPlayer.downloadFunctionPending': '下载功能待实现',

  // 学习管理 - 测试页面
  'pages.learnTest.testPage': '测试页面',
  'pages.learnTest.test': '测试',
  'pages.learnTest.loading': '加载中...',
  'pages.learnTest.question': '题目',
  'pages.learnTest.singleChoice': '单选题',
  'pages.learnTest.multipleChoice': '多选题',
  'pages.learnTest.mark': '标记',
  'pages.learnTest.unmark': '取消标记',
  'pages.learnTest.previous': '上一题',
  'pages.learnTest.next': '下一题',
  'pages.learnTest.answerSheet': '答题卡',
  'pages.learnTest.answered': '已回答',
  'pages.learnTest.current': '当前',
  'pages.learnTest.marked': '已标记',
  'pages.learnTest.submit': '提交',
  'pages.learnTest.abandon': '放弃',
  'pages.learnTest.confirmSubmit': '确认提交',
  'pages.learnTest.confirmSubmitContent': '确定要提交测试答案吗？提交后将无法修改。',
  'pages.learnTest.confirmAbandon': '确认放弃',
  'pages.learnTest.confirmAbandonContent': '确定要放弃测试吗？所有答案将被重置。',
  'pages.learnTest.submitSuccess': '测试提交成功',
  'pages.learnTest.submitFailed': '测试提交失败',
  'pages.learnTest.getTestInfoFailed': '获取测试信息失败',
  'pages.learnTest.getQuestionsFailed': '获取测试题目失败',
  'pages.learnTest.retryRequiredMessage':
    '正确率未达到60%，需要重新学习。完整观看视频后，可以再次参加测试。',

  // 学习管理 - 问题页面
  'pages.learnQuestion.questionPage': '*问题页面',
  'pages.learnQuestion.answerQuestion': '回答问题',
  'pages.learnQuestion.answerContent': '回答内容',
  'pages.learnQuestion.answerContentPlaceholder': '请输入回答内容（10-20000字符）',
  'pages.learnQuestion.answerContentRequired': '请输入回答内容',
  'pages.learnQuestion.answerContentMin': '内容至少10个字符',
  'pages.learnQuestion.answerContentMax': '内容最多20000个字符',
  'pages.learnQuestion.uploadFile': '上传文件',
  'pages.learnQuestion.cancel': '取消',
  'pages.learnQuestion.post': '投稿',
  'pages.learnQuestion.answers': '回答',
  'pages.learnQuestion.noAnswers': '暂无回答',
  'pages.learnQuestion.attachments': '附件：',
  'pages.learnQuestion.statusUpdateSuccess': '状态更新成功',
  'pages.learnQuestion.answerSubmitSuccess': '回答提交成功',
  'pages.learnQuestion.answerSubmitFailed': '回答提交失败',
  'pages.learnQuestion.getQuestionFailed': '获取问题详情失败',
  'pages.learnQuestion.getAnswersFailed': '获取回答列表失败',

  // 学习管理 - 受講者進捗一覧
  'pages.learnProgress.title': '受講者進捗一覧',
  'pages.learnProgress.courseProgressTab': 'コース進捗別',
  'pages.learnProgress.scheduleProgressTab': '日付スケジュール別',
  'pages.learnProgress.courseProgressHeader': '受講者進捗一覧（コース進捗別）',
  'pages.learnProgress.scheduleProgressHeader': '受講者進捗一覧（日付スケジュール別）',
  'pages.learnProgress.participantName': '受講者名',
  'pages.learnProgress.department': '所属',
  'pages.learnProgress.completionRate': '完了率',
  'pages.learnProgress.learningHours': '学習時間',
  'pages.learnProgress.progressStatus': '進捗状況',
  'pages.learnProgress.academicYear': '受講年度',
  'pages.learnProgress.trainingCourse': '研修コース',
  'pages.learnProgress.class': 'クラス',
  'pages.learnProgress.status': 'ステータス',
  'pages.learnProgress.dateRange': '期間',
  'pages.learnProgress.today': '本日',
  'pages.learnProgress.statusNotStarted': '未着手',
  'pages.learnProgress.statusInProgress': '進行中',
  'pages.learnProgress.statusCompleted': '完了',
  'pages.learnProgress.statusOverdue': '期限超過',
  'pages.learnProgress.courseProgressDesc': '受講者ごとのコース別進捗を確認できます',
  'pages.learnProgress.scheduleProgressDesc': '受講者ごとの日付別進捗を確認できます',

  // 学习管理 - 研修数据分析 - 级别称号
  'pages.learnAnalytics.levelTitle.SSR': '传说中的全栈',
  'pages.learnAnalytics.levelTitle.SS': 'Bug 即死狙击手',
  'pages.learnAnalytics.levelTitle.S': '认真读规格书的人',
  'pages.learnAnalytics.levelTitle.A': '认真提交代码的工匠',
  'pages.learnAnalytics.levelTitle.B': '能动就行派',
  'pages.learnAnalytics.levelTitle.C': '调试沼泽潜水员',
  'pages.learnAnalytics.levelTitle.D': '编译错误工匠',
  'pages.learnAnalytics.levelTitle.E': 'PC 重启大师',

  // 学习管理 - 研修数据分析
  'pages.development.learnManagement.analytics.participantName': '受講者名',
  'pages.development.learnManagement.analytics.department': '所属',
  'pages.development.learnManagement.analytics.level': 'レベル',
  'pages.development.learnManagement.analytics.totalScore': '総合スコア',
  'pages.development.learnManagement.analytics.points': '点',
  'pages.development.learnManagement.analytics.averageCompletionRate': '平均完了率',
  'pages.development.learnManagement.analytics.averageCorrectRate': '平均正答率',
  'pages.development.learnManagement.player.testAfterLearning': '学习后测试',
  'pages.development.learnManagement.player.testLockedTooltip': '完整学习视频后即可参加测试。',
  'pages.development.learnManagement.analytics.learningHours': '学習時間',
  'pages.development.learnManagement.analytics.hours': 'h',
  'pages.development.learnManagement.analytics.timeScore': '時間スコア',
  'pages.development.learnManagement.analytics.statusStatistics': 'ステータス統計',
  'pages.development.learnManagement.analytics.recalculateLevel': 'レベル再計算',
  'pages.development.learnManagement.analytics.recalculateSuccess': 'レベル再計算が完了しました',
  'pages.development.learnManagement.analytics.recalculateFailed': 'レベル再計算に失敗しました',
  'pages.development.learnManagement.analytics.statusStatisticsError': '状态统计数据获取失败',
  'pages.development.learnManagement.analytics.total': '合計',
  'pages.development.learnManagement.analytics.person': '人',
  'pages.development.learnManagement.analytics.personUnit': '人',
  'pages.development.learnManagement.analytics.academicYear': '受講年度',
  'pages.development.learnManagement.analytics.selectAcademicYear': '受講年度を選択',
  'pages.development.learnManagement.analytics.class': 'クラス',
  'pages.development.learnManagement.analytics.className': 'クラス名',
  'pages.development.learnManagement.analytics.selectClass': 'クラスを選択',
  'pages.development.learnManagement.analytics.completionStatus': '完了状態',
  'pages.development.learnManagement.analytics.notCompleted': '未完了',
  'pages.development.learnManagement.analytics.completed': '完了',

  // 学习管理 - 受講者進捗一覧
  'pages.development.learnManagement.progress.title': '受講者進捗一覧',
  'pages.development.learnManagement.progress.courseProgressTab': 'コース進捗別',
  'pages.development.learnManagement.progress.testTab': '中コーステスト',
  'pages.development.learnManagement.progress.courseProgressHeader':
    '受講者進捗一覧（コース進捗別）',
  'pages.development.learnManagement.progress.testProgressHeader':
    '受講者進捗一覧（中コーステスト）',
  'pages.development.learnManagement.progress.participantName': '受講者名',
  'pages.development.learnManagement.progress.completionRate': '完了率',
  'pages.development.learnManagement.progress.learningHours': '学習時間',
  'pages.development.learnManagement.progress.testName': 'テスト名',
  'pages.development.learnManagement.progress.score': '点数',
  'pages.development.learnManagement.progress.passFail': '合否',
  'pages.development.learnManagement.progress.completedDate': '完了日',
  'pages.development.learnManagement.progress.academicYear': '受講年度',
  'pages.development.learnManagement.progress.status': 'ステータス',
  'pages.development.learnManagement.progress.selectAcademicYear': '受講年度を選択',
  'pages.development.learnManagement.progress.selectStatus': 'ステータスを選択',
  'pages.development.learnManagement.progress.selectParticipantName': '受講者名を選択',
  'pages.development.learnManagement.progress.selectTestName': 'テスト名を選択',
  'pages.development.learnManagement.progress.passed': '是否合格',
  'pages.development.learnManagement.progress.selectPassed': '是否合格を選択',
  'pages.development.learnManagement.progress.notTaken': '未受験',
  'pages.development.learnManagement.progress.passedStatus': '合格',
  'pages.development.learnManagement.progress.failed': '不合格',
  'pages.development.learnManagement.progress.listView': 'リスト表示',
  'pages.development.learnManagement.progress.matrixView': 'マトリックス表示',
  'pages.development.learnManagement.progress.filterOptionsError': '筛选选项获取失败',
  'pages.development.learnManagement.progress.matrixTitle': '上机测试题目 / 受講者',
  'pages.development.learnManagement.progress.testDescription':
    '受講者ごとのテスト成績を確認できます',
  'pages.development.learnManagement.progress.noData': '暂无数据，请先加载测试成绩数据',
  'pages.development.learnManagement.progress.matrixDescription':
    "* 分数 ≥80 高亮绿色；≥60 蓝色；<60 红色加粗。未受験显示 '-'。矩阵视图便于横向对比各受講者的成绩。",
  'pages.development.learnManagement.progress.statusNotStarted': '未着手',
  'pages.development.learnManagement.progress.statusInProgress': '進行中',
  'pages.development.learnManagement.progress.statusCompleted': '完了',
  'pages.development.learnManagement.progress.statusOverdue': '期限超過',

  // 学习管理 - コース管理
  'pages.development.learnManagement.course.largeCourseTab': '大课程',
  'pages.development.learnManagement.course.mediumCourseTab': '中课程',
  'pages.development.learnManagement.course.largeCourse': '大课程',
  'pages.development.learnManagement.course.mediumCourse': '中课程',
  'pages.development.learnManagement.course.largeCourseName': '大课程名',
  'pages.development.learnManagement.course.largeCourseDescription': '大课程説明',
  'pages.development.learnManagement.course.mediumCourseName': '中课程名',
  'pages.development.learnManagement.course.mediumCourseCode': '中课程コード',
  'pages.development.learnManagement.course.mediumCourseDescription': '中课程説明',
  'pages.development.learnManagement.course.smallCourseCount': '小课程数',
  'pages.development.learnManagement.course.learningProgressName': '学習進捗名',
  'pages.development.learnManagement.course.learningTimeMinutes': '学習時間(分)',
  'pages.development.learnManagement.course.practiceQuestionCount': '練習問題数',
  'pages.development.learnManagement.course.createdDate': '作成日時',
  'pages.development.learnManagement.course.createDate': '作成日時',
  'pages.development.learnManagement.course.operation': '操作',
  'pages.development.learnManagement.course.update': '更新',
  'pages.development.learnManagement.course.delete': '削除',
  'pages.development.learnManagement.course.addLargeCourse': '大课程追加',
  'pages.development.learnManagement.course.addMediumCourse': '中课程追加',
  'pages.development.learnManagement.course.addSmallCourse': '小课程追加',
  'pages.development.learnManagement.course.largeCourseAdd': '大课程追加',
  'pages.development.learnManagement.course.mediumCourseAdd': '中课程追加',
  'pages.development.learnManagement.course.smallCourseAdd': '小课程追加',
  'pages.development.learnManagement.course.batchDelete': '一括削除',
  'pages.development.learnManagement.course.testManagement': 'テスト管理',
  'pages.development.learnManagement.course.largeCourseManagement': '大课程管理',
  'pages.development.learnManagement.course.mediumCourseManagement': '中课程管理',
  'pages.development.learnManagement.course.smallCourseList': '小课程一覧',
  'pages.development.learnManagement.course.largeCourseDeleteConfirm': '大课程削除確認',
  'pages.development.learnManagement.course.largeCourseDeleteDescription':
    'この大课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmTitle': '大课程削除確認',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmDescription':
    'この大课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirm': '中课程削除確認',
  'pages.development.learnManagement.course.mediumCourseDeleteDescription':
    'この中课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmTitle': '中课程削除確認',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmDescription':
    'この中课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseDeleteConfirm': '小课程削除確認',
  'pages.development.learnManagement.course.smallCourseDeleteDescription':
    'この小课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmTitle': '小课程削除確認',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmDescription':
    'この小课程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.cancel': 'キャンセル',
  'pages.development.learnManagement.course.largeCourseDeleting': '大课程を削除中...',
  'pages.development.learnManagement.course.largeCourseDeleted':
    '大课程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.largeCourseDeleteFailed': '大课程の削除に失敗しました',
  'pages.development.learnManagement.course.largeCourseAdding': '大课程を追加中...',
  'pages.development.learnManagement.course.largeCourseAdded': '大课程を追加しました。',
  'pages.development.learnManagement.course.largeCourseAddFailed': '大课程の追加に失敗しました',
  'pages.development.learnManagement.course.largeCourseUpdating': '大课程を更新中...',
  'pages.development.learnManagement.course.largeCourseUpdated': '大课程を更新しました。',
  'pages.development.learnManagement.course.largeCourseUpdateFailed': '大课程の更新に失敗しました',
  'pages.development.learnManagement.course.mediumCourseDeleting': '中课程を削除中...',
  'pages.development.learnManagement.course.mediumCourseDeleted':
    '中课程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.mediumCourseDeleteFailed': '中课程の削除に失敗しました',
  'pages.development.learnManagement.course.mediumCourseAdding': '中课程を追加中...',
  'pages.development.learnManagement.course.mediumCourseAdded': '中课程を追加しました。',
  'pages.development.learnManagement.course.mediumCourseAddFailed': '中课程の追加に失敗しました',
  'pages.development.learnManagement.course.mediumCourseUpdating': '中课程を更新中...',
  'pages.development.learnManagement.course.mediumCourseUpdated': '中课程を更新しました。',
  'pages.development.learnManagement.course.mediumCourseUpdateFailed': '中课程の更新に失敗しました',
  'pages.development.learnManagement.course.smallCourseDeleting': '小课程を削除中...',
  'pages.development.learnManagement.course.smallCourseDeleted':
    '小课程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.smallCourseDeleteFailed': '小课程の削除に失敗しました',
  'pages.development.learnManagement.course.smallCourseAdding': '小课程を追加中...',
  'pages.development.learnManagement.course.smallCourseAdded': '小课程を追加しました。',
  'pages.development.learnManagement.course.smallCourseAddFailed': '小课程の追加に失敗しました',
  'pages.development.learnManagement.course.smallCourseUpdating': '小课程を更新中...',
  'pages.development.learnManagement.course.smallCourseUpdated': '小课程を更新しました。',
  'pages.development.learnManagement.course.smallCourseUpdateFailed': '小课程の更新に失敗しました',
  'pages.development.learnManagement.course.mediumCourseListError': '中课程リスト取得エラー',
  'pages.development.learnManagement.course.largeCourseUpdate': '大课程更新',
  'pages.development.learnManagement.course.largeCourseUpdateTitle': '大课程更新',
  'pages.development.learnManagement.course.largeCourseAddTitle': '大课程追加',
  'pages.development.learnManagement.course.largeCourseNamePlaceholder':
    '例: フロントエンド基礎パック (HTML/CSS/JavaScript)',
  'pages.development.learnManagement.course.largeCourseNameRequired': '大课程名を入力してください',
  'pages.development.learnManagement.course.largeCourseDescriptionPlaceholder':
    '大课程の説明を入力してください',
  'pages.development.learnManagement.course.relatedMediumCourses': '关联中课程',
  'pages.development.learnManagement.course.relatedMediumCoursesPlaceholder':
    '请选择中课程（可多选）',
  'pages.development.learnManagement.course.selectMediumCourses': '请选择中课程（可多选）',
  'pages.development.learnManagement.course.mediumCourseUpdateTitle': '中课程更新',
  'pages.development.learnManagement.course.mediumCourseAddTitle': '中课程追加',
  'pages.development.learnManagement.course.mediumCourseNamePlaceholder':
    '中课程名を入力してください',
  'pages.development.learnManagement.course.mediumCourseNameRequired': '中课程名を入力してください',
  'pages.development.learnManagement.course.mediumCourseCodePlaceholder': '例: HTML',
  'pages.development.learnManagement.course.mediumCourseDescriptionPlaceholder':
    '中课程の説明を入力してください',
  'pages.development.learnManagement.course.mediumCourseStage': '阶段',
  'pages.development.learnManagement.course.mediumCourseStagePlaceholder': '请选择阶段',
  'pages.development.learnManagement.course.stage1': '阶段1：前端学习',
  'pages.development.learnManagement.course.stage2': '第二阶段',
  'pages.development.learnManagement.course.relatedLargeCourseId': '关联大课程ID',
  'pages.development.learnManagement.course.relatedLargeCourseIdPlaceholder':
    '请输入关联大课程ID（可选）',
  'pages.development.learnManagement.course.trainingCourseId': '培训课程ID',
  'pages.development.learnManagement.course.trainingCourseIdPlaceholder': '请输入培训课程ID',
  'pages.development.learnManagement.course.trainingCourseIdRequired': '请输入培训课程ID',
  'pages.development.learnManagement.course.courseStructure': '课程结构',
  'pages.development.learnManagement.course.courseStructurePlaceholder': '请输入课程结构',
  'pages.development.learnManagement.course.smallCourseUpdateTitle': '小课程更新',
  'pages.development.learnManagement.course.smallCourseAddTitle': '小课程追加',
  'pages.development.learnManagement.course.selectMediumCourse': '中课程を選択してください',
  'pages.development.learnManagement.course.mediumCourseSelectPlaceholder': '请选择中课程',
  'pages.development.learnManagement.course.mediumCourseRequired': '中课程を選択してください',
  'pages.development.learnManagement.course.smallCourseName': '小课程名',
  'pages.development.learnManagement.course.smallCourseNamePlaceholder': '请输入小课程名',
  'pages.development.learnManagement.course.smallCourseNameRequired': '请输入小课程名',
  'pages.development.learnManagement.course.smallCourseDescription': '小课程说明',
  'pages.development.learnManagement.course.smallCourseDescriptionPlaceholder': '请输入小课程说明',
  'pages.development.learnManagement.course.learningProgressNamePlaceholder':
    '学習進捗名を入力してください',
  'pages.development.learnManagement.course.learningProgressNameRequired':
    '学習進捗名を入力してください',
  'pages.development.learnManagement.course.learningTimePlaceholder': '学習時間を入力してください',
  'pages.development.learnManagement.course.learningTimeRequired': '学習時間を入力してください',
  'pages.development.learnManagement.course.smallCourseMinutes': '小课程时长(分)',
  'pages.development.learnManagement.course.smallCourseMinutesPlaceholder':
    '请输入小课程时长（分钟）',
  'pages.development.learnManagement.course.smallCourseMinutesRequired': '请输入小课程时长（分钟）',
  'pages.development.learnManagement.course.learningTimeMinutesPlaceholder':
    '学習時間(分)を入力してください',
  'pages.development.learnManagement.course.learningTimeMinutesRequired': '请输入学习时间（分钟）',
  'pages.development.learnManagement.course.practiceQuestionCountPlaceholder':
    '練習問題数を入力してください',
  'pages.development.learnManagement.course.practiceQuestionCountRequired':
    '練習問題数を入力してください',
  'pages.development.learnManagement.course.smallCourseUrl': '小课程URL',
  'pages.development.learnManagement.course.smallCourseUrlPlaceholder': '请输入小课程URL',
  'pages.development.learnManagement.course.smallCourseUrlRequired': '请输入小课程URL',
  'pages.development.learnManagement.course.orderNo': '順序番号',
  'pages.development.learnManagement.course.orderNoPlaceholder':
    '順序番号を入力してください（オプション）',
  'pages.development.learnManagement.course.no': '番号',
  'pages.development.learnManagement.course.testManagementTitle': 'テスト管理',
  'pages.development.learnManagement.course.smallCourseId': '小课程ID',
  'pages.development.learnManagement.course.questionDeleted': '题目を削除しました',
  'pages.development.learnManagement.course.questionDeleteFailed': '题目の削除に失敗しました',
  'pages.development.learnManagement.course.questionUpdated': '题目を更新しました',
  'pages.development.learnManagement.course.questionAdded': '题目を追加しました',
  'pages.development.learnManagement.course.operationFailed': '操作に失敗しました',
  'pages.development.learnManagement.course.questionDeleteConfirm': '题目削除確認',
  'pages.development.learnManagement.course.questionDeleteDescription':
    'この题目を削除してもよろしいですか？',
  'pages.development.learnManagement.course.questionEdit': '题目編集',
  'pages.development.learnManagement.course.questionAdd': '题目追加',
  'pages.development.learnManagement.course.addQuestion': '题目增加',
  'pages.development.learnManagement.course.edit': '編集',
  'pages.development.learnManagement.course.questionContent': '题目内容',
  'pages.development.learnManagement.course.questionContentPlaceholder':
    '题目内容を入力してください',
  'pages.development.learnManagement.course.questionContentRequired': '题目内容を入力してください',
  'pages.development.learnManagement.course.questionType': '题目类型',
  'pages.development.learnManagement.course.questionTypeRequired': '题目类型を選択してください',
  'pages.development.learnManagement.course.singleChoice': '単一選択',
  'pages.development.learnManagement.course.multipleChoice': '多選択',
  'pages.development.learnManagement.course.addOption': '选项追加',
  'pages.development.learnManagement.course.option': '选项{index}',
  'pages.development.learnManagement.course.optionPlaceholder': '选项{index}を入力してください',
  'pages.development.learnManagement.course.optionContentRequired': '选项内容を入力してください',
  'pages.development.learnManagement.course.optionsMinRequired': '少なくとも2つの选项が必要です',
  'pages.development.learnManagement.course.correctAnswer': '正解',
  'pages.development.learnManagement.course.correctAnswerRequired': '正解を選択してください',
  'pages.development.learnManagement.course.correctAnswerAtLeastOneRequired':
    '少なくとも1つの正解を選択してください',
  'pages.development.learnManagement.course.optionCount': '选项数',
  'pages.development.learnManagement.course.questionDeleteConfirmTitle': '题目削除確認',
  'pages.development.learnManagement.course.questionDeleteConfirmDescription':
    'この题目を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseUpdate': '小课程更新',
  'pages.development.learnManagement.course.selectedItems': '已选择',
  'pages.development.learnManagement.course.items': '项',
  'pages.development.learnManagement.course.qaManagement': 'QA管理',
  'pages.development.learnManagement.course.mediumCourseId': '中课程ID',
  'pages.development.learnManagement.course.qaContent': 'QA内容',
  'pages.development.learnManagement.course.questionerName': '提问者名称',
  'pages.development.learnManagement.course.manageAnswers': '管理回答',
  'pages.development.learnManagement.course.addQa': '添加QA',
  'pages.development.learnManagement.course.qaDeleted': 'QA已删除',
  'pages.development.learnManagement.course.qaDeleteFailed': 'QA删除失败',
  'pages.development.learnManagement.course.qaUpdated': 'QA已更新',
  'pages.development.learnManagement.course.qaAdded': 'QA已添加',
  'pages.development.learnManagement.course.qaEdit': 'QA编辑',
  'pages.development.learnManagement.course.qaAdd': 'QA添加',
  'pages.development.learnManagement.course.qaAnswerManagement': 'QA回答管理',
  'pages.development.learnManagement.course.addAnswer': '添加回答',
  'pages.development.learnManagement.course.answerEdit': '回答编辑',
  'pages.development.learnManagement.course.answerAdd': '回答添加',
  'pages.development.learnManagement.course.answerContent': '回答内容',
  'pages.development.learnManagement.course.responderName': '回答者名称',
  'pages.development.learnManagement.course.answerDeleted': '回答已删除',
  'pages.development.learnManagement.course.answerDeleteFailed': '回答删除失败',
  'pages.development.learnManagement.course.answerUpdated': '回答已更新',
  'pages.development.learnManagement.course.answerAdded': '回答已添加',
  'pages.development.learnManagement.course.answerDeleteConfirmTitle': '回答删除确认',
  'pages.development.learnManagement.course.answerDeleteConfirmDescription': '确定要删除此回答吗？',
  'pages.development.learnManagement.course.qaContentPlaceholder': '请输入QA内容',
  'pages.development.learnManagement.course.qaContentRequired': '请输入QA内容',
  'pages.development.learnManagement.course.qaAnswer': 'QA答案',
  'pages.development.learnManagement.course.qaAnswerPlaceholder': '请输入QA答案',
  'pages.development.learnManagement.course.qaAnswerRequired': '请选择QA答案',
  'pages.development.learnManagement.course.qaComment': 'QA备注',
  'pages.development.learnManagement.course.qaCommentPlaceholder': '请输入QA备注',
  'pages.development.learnManagement.course.qaChooseA': '选项A',
  'pages.development.learnManagement.course.qaChooseAPlaceholder': '请输入选项A',
  'pages.development.learnManagement.course.qaChooseARequired': '请输入选项A',
  'pages.development.learnManagement.course.qaChooseB': '选项B',
  'pages.development.learnManagement.course.qaChooseBPlaceholder': '请输入选项B',
  'pages.development.learnManagement.course.qaChooseBRequired': '请输入选项B',
  'pages.development.learnManagement.course.qaChooseC': '选项C',
  'pages.development.learnManagement.course.qaChooseCPlaceholder': '请输入选项C',
  'pages.development.learnManagement.course.qaChooseCRequired': '请输入选项C',
  'pages.development.learnManagement.course.qaChooseD': '选项D',
  'pages.development.learnManagement.course.qaChooseDPlaceholder': '请输入选项D',
  'pages.development.learnManagement.course.qaChooseDRequired': '请输入选项D',

  // Course Player
  'pages.development.learnManagement.player.mediumCourseIdNotFound': '中课程ID不存在',
  'pages.development.learnManagement.player.smallCourseCount': '小课程数量',
  'pages.development.learnManagement.player.loading': '加载中...',
  'pages.development.learnManagement.player.noCurrentTask': '当前没有任务',
  'pages.development.learnManagement.player.task': '任务',
  'pages.development.learnManagement.player.courseAndTest': '听课・测试',
  'pages.development.learnManagement.player.mediumCourseTest': '中课程测试',

  // Learn Progress
  'pages.development.learnManagement.progress.participantNameInput': '请输入学员姓名',
  'pages.development.learnManagement.progress.level': '学员等级',
  'pages.development.learnManagement.progress.levelSelect': '请选择等级',
  'pages.development.learnManagement.progress.level1': '等级 1',
  'pages.development.learnManagement.progress.level2': '等级 2',
  'pages.development.learnManagement.progress.level3': '等级 3',
  'pages.development.learnManagement.progress.level4': '等级 4',
  'pages.development.learnManagement.progress.level5': '等级 5',
  'pages.development.learnManagement.progress.statusExcellent': '优秀 · 稳定',
  'pages.development.learnManagement.progress.statusGood': '良好 · 观察',
  'pages.development.learnManagement.progress.statusAverage': '普通 · 需跟进',
  'pages.development.learnManagement.progress.statusFail': '风险 · 重点介入',
  'pages.development.learnManagement.progress.statusBomb': '风险 · 重点介入',
  'pages.development.learnManagement.progress.levelAndScore': 'レベル・平均点',
  'pages.development.learnManagement.progress.averageScore': '平均分',
  'pages.development.learnManagement.progress.learningTask': '学习任务',
  'pages.development.learnManagement.progress.learningRemark': '评价备注',
  'pages.development.learnManagement.progress.operation': '操作',
  'pages.development.learnManagement.progress.noPermission': '没有权限',
  'pages.development.learnManagement.progress.taskManagement': '任务管理',
  'pages.development.learnManagement.progress.remarkManagement': '评价备注管理',
  'pages.development.learnManagement.progress.mediumCourseName': '中课程名称',
  'pages.development.learnManagement.progress.mediumCourseNameSelect': '请选择中课程名称',
  'pages.development.learnManagement.progress.participantNameInputExample': '例：张三 / Tanaka',
  'pages.development.learnManagement.progress.recalcComplete':
    '重算完成: 处理对象 {processedAccounts}, 新增 {insertedCount}, 更新 {updatedCount}',
  'pages.development.learnManagement.progress.recalc': '重算',
  'pages.development.learnManagement.progress.taskInputRequired': '请输入学习任务',
  'pages.development.learnManagement.progress.taskUpdated': '任务已更新',
  'pages.development.learnManagement.progress.taskInputPlaceholder': '请输入学习任务',
  'pages.development.learnManagement.progress.remarkUpdated': '备考已更新',
  'pages.development.learnManagement.progress.remarkInputPlaceholder':
    '请输入评价、所見等内容（例：学习积极性高、团队协作能力强等）',
  'pages.development.learnManagement.progress.remarkHint': '※ 可以自由记录学员的评价、所見、建议等',
  'pages.development.learnManagement.course.qaDeleteConfirmTitle': 'QA削除確認',
  'pages.development.learnManagement.course.qaDeleteConfirmDescription': '确定要删除此QA吗？',
  'pages.development.learnManagement.course.mediumCourseRelationManagement': '中课程关联管理',
  'pages.development.learnManagement.course.relationManagementTitle': '课程信息编辑',
  'pages.development.learnManagement.course.reset': '重置',
  'pages.development.learnManagement.course.confirm': '确认',
  'pages.development.learnManagement.course.relationLoadFailed': '关联信息加载失败',
  'pages.development.learnManagement.course.relationUpdated': '关联关系更新成功',
  'pages.development.learnManagement.course.relationUpdateFailed': '关联更新失败',

  // 学习管理 - プレイヤー
  'pages.development.learnManagement.player.saveProgressSuccess': '学習進捗を保存しました',
  'pages.development.learnManagement.player.saveProgressFailed': '学習進捗の保存に失敗しました',
  'pages.development.learnManagement.player.testIdNotSet': 'テストIDが設定されていません',
  'pages.development.learnManagement.player.videoUrlNotSet': '動画URLが設定されていません',
  'pages.development.learnManagement.player.test': 'テスト',
  'pages.development.learnManagement.player.play': '再生',
  'pages.development.learnManagement.player.completeVideoFirst': '请先完成视频观看',
  'pages.development.learnManagement.player.currentSection': '当前章节',
  'pages.development.learnManagement.player.cancel': '取消',
  'pages.development.learnManagement.player.confirm': '确认',

  // 営業部 - 請求書一覧
  'pages.invoiceList.invoice': '請求書',
  'pages.invoiceList.payment': '入金予定',
  'pages.invoiceList.operation': '操作',
  'pages.invoiceList.invoiceCreate': '請求書作成',
  'pages.invoiceList.invoiceCreate.all': '請求書一括作成',
  'pages.invoiceList.create.process': '請求書作成中・・・',
  'pages.invoiceList.create.done': '請求書作成しました。',
  'pages.invoiceList.payment.update': '入金状態更新',
  'pages.invoiceList.payment.update.process': '入金状態更新中・・・',
  'pages.invoiceList.payment.update.done': '入金状態更新しました。',

  // 総務部 - 交通費一覧
  'pages.commuteList.title': '通勤费一览',
  'pages.commuteList.employeeId': '社员ID',
  'pages.commuteList.progress': '进度',
  'pages.commuteList.employeeName': '社员名',
  'pages.commuteList.amount': '金额',
  'pages.commuteList.submitStatus': '提交状态',
  'pages.commuteList.approvalStatus': '承認状态',
  'pages.commuteList.operation': '操作',
  'pages.commuteList.detail': '详情',
  'pages.commuteList.remind': '提醒',
  'pages.commuteList.remindConfirm': '发送提醒确认',
  'pages.commuteList.remindConfirmContent': '确定要向「{name}」发送提交提醒吗？',
  'pages.commuteList.remindSuccess': '提醒发送成功',
  'pages.commuteList.remindFailed': '提醒发送失败',
  'pages.commuteList.all': '全部',
  'pages.commuteList.notApplied': '未申请',
  'pages.commuteList.notAllSubmitted': '提交中',
  'pages.commuteList.allSubmitted': '待审批',
  'pages.commuteList.approved': '完成',
  'pages.commuteList.total': '合计',
  'pages.commuteList.reload': '重新加载',
  'pages.commuteList.search.button': '搜索',
  'pages.commuteList.search.placeholder':
    '按社员ID / 账号名 / 社员名 / 提交状态 / 审批状态 / 金额搜索',
  'pages.commuteList.search.result': '搜索结果',
  'pages.commuteList.search.countUnit': '件',
  'pages.commuteList.remindAll': '一键提醒',
  'pages.commuteList.noPermission': '没有使用此功能的权限。',
  'pages.commuteList.fetchFailed': '获取通勤费列表失败。',
  'pages.commuteCommit.status.notSubmitted': '未提交',
  'pages.commuteCommit.status.pendingApproval': '待审批',
  'pages.commuteCommit.status.approved': '已审批',
  'pages.commuteCommit.status.rejected': '退回',
  'pages.commuteCommit.reject.action': '驳回',
  'pages.commuteCommit.reject.title': '通勤费驳回（退回）',
  'pages.commuteCommit.reject.placeholder': '请输入驳回理由',
  'pages.commuteCommit.reject.ok': '退回',
  'pages.commuteCommit.reject.cancel': '取消',
  'pages.commuteCommit.reject.requireReason': '请输入驳回理由。',
  'pages.commuteCommit.column.no': 'No',
  'pages.commuteCommit.column.commuteType': '通勤费类型',
  'pages.commuteCommit.column.period': '期间',
  'pages.commuteCommit.column.amount': '金额',
  'pages.commuteCommit.column.status': '审批状态',
  'pages.commuteCommit.column.remarks': '备注',
  'pages.commuteCommit.column.receipt': '收据',
  'pages.commuteCommit.column.actions': '操作',
  'pages.commuteCommit.receipt.show': '显示',
  'pages.commuteCommit.receipt.none': '无收据',
  'pages.commuteCommit.action.delete': '删除',
  'pages.commuteCommit.action.submit': '提交',
  'pages.commuteCommit.action.approve': '承认',
  'pages.commuteCommit.confirm.ok': '是',
  'pages.commuteCommit.confirm.cancel': '否',
  'pages.commuteCommit.delete.title': '通勤费删除确认',
  'pages.commuteCommit.delete.confirm': '确定要删除吗？',
  'pages.commuteCommit.submit.title': '通勤费提交确认',
  'pages.commuteCommit.submit.confirm': '确定要提交吗？',
  'pages.commuteCommit.approve.title': '通勤费承认确认',
  'pages.commuteCommit.approve.confirm': '确定要承认吗？',
  'pages.commuteCommit.header.month': '{year}年{month}月',

  // 请假申请 (OARequests)
  'pages.oaRequests.title': '请假申请',
  'pages.oaRequests.column.requestId': '申请',
  'pages.oaRequests.column.status': '状态',
  'pages.oaRequests.column.leavePeriod': '请假期间',
  'pages.oaRequests.column.reason': '请假理由',
  'pages.oaRequests.column.rejectReason': '驳回理由',
  'pages.oaRequests.column.approvalStep': '审批步骤',
  'pages.oaRequests.column.actions': '操作',
  'pages.oaRequests.status.draft': '草稿',
  'pages.oaRequests.status.submitted': '已申请，待审批',
  'pages.oaRequests.status.approved': '已审批',
  'pages.oaRequests.status.rejected': '已驳回',
  'pages.oaRequests.status.cancelled': '已取消',
  'pages.oaRequests.action.detail': '详情',
  'pages.oaRequests.action.edit': '编辑',
  'pages.oaRequests.action.submit': '提交',
  'pages.oaRequests.action.cancel': '取消',
  'pages.oaRequests.action.delete': '删除',
  'pages.oaRequests.action.create': '新建请假申请',
  'pages.oaRequests.action.update': '更新',
  'pages.oaRequests.action.saveDraft': '保存草稿',
  'pages.oaRequests.action.createAndSubmit': '创建并提交',
  'pages.oaRequests.action.cancelBtn': '取消',
  'pages.oaRequests.action.back': '返回',
  'pages.oaRequests.modal.editTitle': '编辑请假申请',
  'pages.oaRequests.modal.createTitle': '创建连续请假申请',
  'pages.oaRequests.drawer.title': '请假申请详情',
  'pages.oaRequests.confirm.submit': '确定要提交这个请假申请吗？',
  'pages.oaRequests.confirm.submitMultiple': '确定要提交这段时间的请假申请吗？',
  'pages.oaRequests.confirm.submitDescription':
    '提交后将无法编辑申请内容。如果需要修改，请取消后重新申请。',
  'pages.oaRequests.confirm.cancel': '确定要取消这个请假申请吗？',
  'pages.oaRequests.confirm.cancelMultiple': '确定要取消这段时间的请假申请吗？',
  'pages.oaRequests.confirm.delete': '确定要删除已取消的请假申请吗？',
  'pages.oaRequests.confirm.deleteMultiple': '确定要批量删除已取消的请假申请吗？',
  'pages.oaRequests.confirm.deleteDescription': '删除后，这些申请将不再显示在列表中。',
  'pages.oaRequests.field.leaveDate': '请假日期',
  'pages.oaRequests.field.leavePeriod': '请假期间',
  'pages.oaRequests.field.leaveType': '请假类型',
  'pages.oaRequests.field.leaveStartDate': '请假开始日',
  'pages.oaRequests.field.leaveEndDate': '请假结束日',
  'pages.oaRequests.field.leaveStartTime': '开始时间',
  'pages.oaRequests.field.leaveEndTime': '结束时间',
  'pages.oaRequests.field.reason': '请假理由',
  'pages.oaRequests.leaveType.fullDay': '全天请假',
  'pages.oaRequests.leaveType.hourly': '小时请假',
  'pages.oaRequests.validation.leaveDate': '请选择请假日期。',
  'pages.oaRequests.validation.leavePeriod': '请选择请假期间。',
  'pages.oaRequests.confirm.longPeriodTitle': '长期请假申请',
  'pages.oaRequests.confirm.longPeriodDescription':
    '申请期间为{days}天，超过了通常的{warningDays}天。请确认年份和期间无误后再继续。',
  'pages.oaRequests.confirm.longPeriodContinue': '确认并继续',
  'pages.oaRequests.validation.leaveType': '请选择请假类型。',
  'pages.oaRequests.validation.leaveStartDate': '请选择请假开始日。',
  'pages.oaRequests.validation.leaveEndDate': '请选择请假结束日。',
  'pages.oaRequests.validation.leaveDateOrder': '请假结束日必须晚于或等于开始日。',
  'pages.oaRequests.validation.leaveStartTime': '请选择开始时间。',
  'pages.oaRequests.validation.leaveEndTime': '请选择结束时间。',
  'pages.oaRequests.validation.leaveTimeRange':
    '时间必须在08:00〜20:00范围内，并按15分钟单位输入。',
  'pages.oaRequests.validation.leaveTimeOrder': '结束时间必须晚于开始时间。',
  'pages.oaRequests.validation.reason': '请输入请假理由。',
  'pages.oaRequests.msg.submitSuccess': '请假申请已提交。',
  'pages.oaRequests.msg.submitMultipleSuccess': '已提交{count}件请假申请。',
  'pages.oaRequests.msg.submitFailed': '提交请假申请失败。',
  'pages.oaRequests.msg.cancelSuccess': '请假申请已取消。',
  'pages.oaRequests.msg.cancelMultipleSuccess': '已取消{count}件请假申请。',
  'pages.oaRequests.msg.cancelFailed': '取消请假申请失败。',
  'pages.oaRequests.msg.deleteSuccess': '已删除取消后的请假申请。',
  'pages.oaRequests.msg.deleteMultipleSuccess': '已删除{count}件取消后的请假申请。',
  'pages.oaRequests.msg.deleteFailed': '删除取消后的请假申请失败。',
  'pages.oaRequests.msg.updateSuccess': '请假申请已更新。',
  'pages.oaRequests.msg.updateFailed': '更新请假申请失败。',
  'pages.oaRequests.msg.createSuccess': '连续请假申请已创建。',
  'pages.oaRequests.msg.createAndSubmitSuccess': '连续请假申请已提交。',
  'pages.oaRequests.msg.createFailed': '保存连续请假申请失败。',
  'pages.oaRequests.msg.detailFailed': '获取请假申请详情失败。',
  'pages.oaRequests.detail.requestId': '申请ID',
  'pages.oaRequests.detail.applicant': '申请人',
  'pages.oaRequests.detail.status': '状态',
  'pages.oaRequests.detail.leaveDate': '请假日期',
  'pages.oaRequests.detail.leaveType': '请假类型',
  'pages.oaRequests.detail.leaveTime': '时间段',
  'pages.oaRequests.detail.leaveDuration': '请假时间',
  'pages.oaRequests.detail.approvalStep': '审批步骤',
  'pages.oaRequests.detail.originalInTime': '原上班时间',
  'pages.oaRequests.detail.originalBreakTime': '原休息时间',
  'pages.oaRequests.detail.originalOutTime': '原下班时间',
  'pages.oaRequests.detail.reason': '请假理由',
  'pages.oaRequests.detail.rejectReason': '驳回理由',
  'pages.oaRequests.detail.leaveFlag': '休假',
  'pages.oaRequests.detail.workFlag': '出勤',
  'pages.oaRequests.itemCount': '{count}件',
  'pages.oaRequests.dayCount': '{count}天',
  'pages.oaRequests.approvalHistory.step': 'STEP',
  'pages.oaRequests.approvalHistory.stepName': '步骤名称',
  'pages.oaRequests.approvalHistory.approverRole': '审批角色',
  'pages.oaRequests.approvalHistory.status': '状态',
  'pages.oaRequests.approvalHistory.actionBy': '处理人',
  'pages.oaRequests.approvalHistory.comment': '评论',
  'pages.oaRequests.approvalHistory.actionAt': '处理时间',

  // 请假审批 (OAApprovals)
  'pages.oaApprovals.title': '请假审批',
  'pages.oaApprovals.tab.pending': '待审批',
  'pages.oaApprovals.tab.history': '审批历史',
  'pages.oaApprovals.historyScope.all': '全部',
  'pages.oaApprovals.historyScope.mine': '仅看我处理的',
  'pages.oaApprovals.column.request': '申请',
  'pages.oaApprovals.column.applicant': '申请人',
  'pages.oaApprovals.column.status': '状态',
  'pages.oaApprovals.column.leavePeriod': '请假期间',
  'pages.oaApprovals.column.approvalStep': '审批步骤',
  'pages.oaApprovals.column.reason': '请假理由',
  'pages.oaApprovals.column.appliedAt': '申请时间',
  'pages.oaApprovals.column.actionAt': '处理时间',
  'pages.oaApprovals.column.actions': '操作',
  'pages.oaApprovals.action.detail': '详情',
  'pages.oaApprovals.action.approve': '审批',
  'pages.oaApprovals.action.reject': '驳回',
  'pages.oaApprovals.confirm.approve': '确定要审批这个请假申请吗？',
  'pages.oaApprovals.confirm.approveMultiple': '确定要审批这段时间的请假申请吗？',
  'pages.oaApprovals.confirm.back': '返回',
  'pages.oaApprovals.reject.title': '驳回',
  'pages.oaApprovals.reject.reason': '驳回理由',
  'pages.oaApprovals.reject.validation': '请输入驳回理由。',
  'pages.oaApprovals.msg.loadFailed': '获取请假审批列表失败。',
  'pages.oaApprovals.msg.detailFailed': '获取请假申请详情失败。',
  'pages.oaApprovals.msg.approveSuccess': '请假申请已审批。',
  'pages.oaApprovals.msg.approveMultipleSuccess': '已审批{count}件请假申请。',
  'pages.oaApprovals.msg.approveFailed': '审批请假申请失败。',
  'pages.oaApprovals.msg.rejectSuccess': '请假申请已驳回。',
  'pages.oaApprovals.msg.rejectMultipleSuccess': '已驳回{count}件请假申请。',
  'pages.oaApprovals.msg.rejectFailed': '驳回请假申请失败。',
  'pages.oaApprovals.drawer.title': '请假申请详情',
  'pages.oaApprovals.summary.leaveRequest': '请假申请 {label}',
  'pages.oaApprovals.summary.requestId': '申请ID: {ids}',
  'pages.oaApprovals.summary.periodMultiple': '{count}天',
  'pages.oaApprovals.summary.periodSingle': '1天',
  'pages.oaApprovals.detail.requestId': '申请ID',
  'pages.oaApprovals.detail.applicant': '申请人',
  'pages.oaApprovals.detail.status': '状态',
  'pages.oaApprovals.detail.leaveDate': '请假日期',
  'pages.oaApprovals.detail.originalInTime': '原上班时间',
  'pages.oaApprovals.detail.originalBreakTime': '原休息时间',
  'pages.oaApprovals.detail.originalOutTime': '原下班时间',
  'pages.oaApprovals.detail.reason': '请假理由',
  'pages.oaApprovals.detail.rejectReason': '驳回理由',

  // 请假审批流程 (OAWorkflows)
  'pages.oaWorkflows.title': '请假审批流程',
  'pages.oaWorkflows.column.workflowName': '流程名称',
  'pages.oaWorkflows.column.active': '有效',
  'pages.oaWorkflows.column.steps': '审批步骤',
  'pages.oaWorkflows.column.actions': '操作',
  'pages.oaWorkflows.action.edit': '编辑',
  'pages.oaWorkflows.modal.editTitle': '编辑请假审批流程',
  'pages.oaWorkflows.field.workflowName': '流程名称',
  'pages.oaWorkflows.field.active': '有效',
  'pages.oaWorkflows.field.steps': '审批步骤',
  'pages.oaWorkflows.field.stepNo': '步骤编号',
  'pages.oaWorkflows.field.stepName': '步骤名称',
  'pages.oaWorkflows.field.approverRole': '审批角色',
  'pages.oaWorkflows.step.stepNo': '步骤编号',
  'pages.oaWorkflows.step.stepName': '步骤名称',
  'pages.oaWorkflows.step.approverRole': '审批角色',
  'pages.oaWorkflows.validation.workflowName': '请输入流程名称。',
  'pages.oaWorkflows.validation.stepNo': '请输入步骤编号。',
  'pages.oaWorkflows.validation.stepName': '请输入步骤名称。',
  'pages.oaWorkflows.validation.approverRole': '请选择审批角色。',
  'pages.oaWorkflows.validation.noticeEmails': '通知邮箱格式不正确。',
  'pages.oaWorkflows.step.noticeEmails': '追加通知邮箱',
  'pages.oaWorkflows.step.noticeEmailsPlaceholder': '输入通知邮箱后按 Enter',
  'pages.oaWorkflows.step.noticeEmailCount': '追加通知: {count}件',
  'pages.oaWorkflows.action.addStep': '添加步骤',
  'pages.oaWorkflows.action.delete': '删除',
  'pages.oaWorkflows.action.deleteStep': '删除',
  'pages.oaWorkflows.msg.loadFailed': '获取请假审批流程失败。',
  'pages.oaWorkflows.msg.updateSuccess': '请假审批流程已更新。',
  'pages.oaWorkflows.msg.updateFailed': '更新请假审批流程失败。',

  // 共通
  'pages.attendance.yes': 'はい',
  'pages.attendance.no': 'いいえ',
  'pages.attendance.accountId': '社員ID',
  'pages.attendance.employeeName': '社員名',
  'pages.attendance.search.button': '搜索',
  'pages.attendance.search.placeholder': '按社员ID / 账号名 / 社员名 / 角色 / 状态搜索',
  'pages.attendance.search.result': '搜索结果',
  'pages.attendance.search.countUnit': '件',
  'pages.accounting.salaryManagement.title': '工资管理',
  'pages.accounting.salaryManagement.search.button': '检索',
  'pages.accounting.salaryManagement.search.placeholder': '按员工ID / 员工名 / 账号检索',
  'pages.accounting.salaryManagement.search.result': '检索结果',
  'pages.accounting.salaryManagement.search.countUnit': '件',
  'pages.accounting.salaryManagement.summary.companyActualIncome': '公司总实际收入',
  'pages.accounting.salaryManagement.summary.scope':
    '按所选月份的在职期间汇总公司实际收入。现在已离职或停用的人员，历史在职月份仍计入；不受搜索和分类影响。在职期间不明或离职后结算须核对。',
  'pages.accounting.salaryManagement.summary.pendingHelp':
    '存在无法计算的人员时，显示“需要确认”，不将部分合计作为公司总收入。',
  'pages.accounting.salaryManagement.summary.pendingCount': '待确认人数',
  'pages.accounting.salaryManagement.reload': '重新加载',
  'pages.accounting.salaryManagement.filter.contractType': '契约形态',
  'pages.accounting.salaryManagement.filter.targetMonth': '对象年月',
  'pages.accounting.salaryManagement.contractType.trainee': '就业导向',
  'pages.accounting.salaryManagement.contractType.internal': '研修员工（内定者）',
  'pages.accounting.salaryManagement.contractType.contract': '契约员工',
  'pages.accounting.salaryManagement.contractType.employee': '契约・正式员工',
  'pages.accounting.salaryManagement.contractType.regular': '正式员工',
  'pages.accounting.salaryManagement.contractType.bp': 'BP员工',
  'pages.accounting.salaryManagement.contractType.resigned': '已离职',
  'pages.accounting.salaryManagement.accountStatus.active': '正在使用',
  'pages.accounting.salaryManagement.accountStatus.disabled': '停用',
  'pages.accounting.salaryManagement.status.active': '在职中',
  'pages.accounting.salaryManagement.status.undefined': '未定',
  'pages.accounting.salaryManagement.status.contractFinished': '合同期满',
  'pages.accounting.salaryManagement.status.bpFinished': 'BP结束',
  'pages.accounting.salaryManagement.status.resigned': '已离职',
  'pages.accounting.salaryManagement.column.employeeId': '员工ID',
  'pages.accounting.salaryManagement.column.employeeName': '员工名',
  'pages.accounting.salaryManagement.column.accountStatus': '账号状态',
  'pages.accounting.salaryManagement.column.contractType': '契约形态',
  'pages.accounting.salaryManagement.column.status': '状态',
  'pages.accounting.salaryManagement.column.currentSalary': '基本工资',
  'pages.accounting.salaryManagement.column.specialAllowance': '特别补贴',
  'pages.accounting.salaryManagement.column.employerBurden': '公司额外负担预估',
  'pages.accounting.salaryManagement.column.totalCompanyCost': '公司总成本',
  'pages.accounting.salaryManagement.column.projectRevenue': '案件收入',
  'pages.accounting.salaryManagement.column.companyActualIncome': '公司实际收入',
  'pages.accounting.salaryManagement.projectRevenueHelp':
    '所选月份的案件收入（预计、税前）。已开票使用明细金额，未开票使用案件单价。',
  'pages.accounting.salaryManagement.companyActualIncomeHelp':
    '公司实际收入 = 案件收入 − 公司总成本。',
  'pages.accounting.salaryManagement.column.lastRaiseAmount': '最近涨薪额',
  'pages.accounting.salaryManagement.column.lastRaiseDate': '最近涨薪日',
  'pages.accounting.salaryManagement.column.nextRaisePlannedDate': '下次涨薪预定日',
  'pages.accounting.salaryManagement.column.action': '操作',
  'pages.accounting.salaryManagement.modal.editTitle': '工资信息编辑',
  'pages.accounting.salaryManagement.modal.historyTitle': '涨薪履历',
  'pages.accounting.salaryManagement.modal.historyTitleWithName': '{name} 的涨薪履历',
  'pages.accounting.salaryManagement.label.beforeSaveCurrentSalary': '保存前的基本工资',
  'pages.accounting.salaryManagement.field.currentSalary': '基本工资',
  'pages.accounting.salaryManagement.field.specialAllowance': '特别补贴',
  'pages.accounting.salaryManagement.field.specialAllowance.extra':
    '这是{month}月份的一次性补贴，会计入雇佣保险、劳灾保险及公司总成本。',
  'pages.accounting.salaryManagement.insuranceSettings.title': '保险计算设置',
  'pages.accounting.salaryManagement.field.socialInsuranceApplicable': '社会保险',
  'pages.accounting.salaryManagement.field.employmentInsuranceApplicable': '雇佣保险',
  'pages.accounting.salaryManagement.field.careInsuranceMode': '介护保险判定',
  'pages.accounting.salaryManagement.option.applicable': '适用',
  'pages.accounting.salaryManagement.option.notApplicable': '不适用',
  'pages.accounting.salaryManagement.option.careAuto': '根据出生日期自动判定',
  'pages.accounting.salaryManagement.option.careOn': '适用',
  'pages.accounting.salaryManagement.option.careOff': '不适用',
  'pages.accounting.salaryManagement.field.healthStandardOverride':
    '健康保险标准报酬月额（手动设置）',
  'pages.accounting.salaryManagement.field.pensionStandardOverride':
    '厚生年金标准报酬月额（手动设置）',
  'pages.accounting.salaryManagement.field.standardOverride.extra':
    '不填写时会根据基本工资自动判定等级，仅在已有申报标准报酬月额时填写。',
  'pages.accounting.salaryManagement.field.lastRaiseDate': '最近涨薪日',
  'pages.accounting.salaryManagement.field.lastRaiseAmount': '最近涨薪额',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate': '下次涨薪预定日',
  'pages.accounting.salaryManagement.helper.syncHistory':
    '保存最近涨薪日和最近涨薪额后，也会同步反映到履历中的最新1条记录。',
  'pages.accounting.salaryManagement.history.column.raiseDate': '涨薪日',
  'pages.accounting.salaryManagement.history.column.beforeCurrentSalary': '涨薪前工资',
  'pages.accounting.salaryManagement.history.column.afterCurrentSalary': '涨薪后工资',
  'pages.accounting.salaryManagement.history.column.raiseAmount': '涨薪额',
  'pages.accounting.salaryManagement.history.column.nextRaisePlannedDate': '下次涨薪预定日',
  'pages.accounting.salaryManagement.history.column.createdAt': '登记时间',
  'pages.accounting.salaryManagement.history.column.targetMonth': '对象年月',
  'pages.accounting.salaryManagement.history.column.updatedAt': '更新时间',
  'pages.accounting.salaryManagement.history.tab.salary': '涨薪履历',
  'pages.accounting.salaryManagement.history.tab.specialAllowance': '特别补贴履历',
  'pages.accounting.salaryManagement.history.empty': '暂无履历。',
  'pages.accounting.salaryManagement.history.deleteConfirm': '确定删除这条履历吗？',
  'pages.accounting.salaryManagement.action.edit': '编辑',
  'pages.accounting.salaryManagement.action.history': '履历',
  'pages.accounting.salaryManagement.action.save': '保存',
  'pages.accounting.salaryManagement.action.cancel': '取消',
  'pages.accounting.salaryManagement.action.delete': '删除',
  'pages.accounting.salaryManagement.msg.loadFailed': '获取工资管理数据失败。',
  'pages.accounting.salaryManagement.msg.filterFailed': '筛选工资管理数据失败。',
  'pages.accounting.salaryManagement.msg.saveSuccess': '工资信息已保存。',
  'pages.accounting.salaryManagement.msg.saveFailed': '工资信息保存失败。',
  'pages.accounting.salaryManagement.msg.historyLoadFailed': '获取涨薪履历失败。',
  'pages.accounting.salaryManagement.msg.specialAllowanceHistoryLoadFailed':
    '获取特别补贴履历失败。',
  'pages.accounting.salaryManagement.msg.historyDeleteSuccess': '涨薪履历已删除。',
  'pages.accounting.salaryManagement.msg.historyDeleteFailed': '删除涨薪履历失败。',
  'pages.accounting.salaryManagement.guide.title':
    '工资管理页面可以统一查看基本工资、月度特别补贴和公司负担预估。',
  'pages.accounting.salaryManagement.guide.line1':
    '选择对象年月后，通过“编辑”更新基本工资、特别补贴和保险计算设置。',
  'pages.accounting.salaryManagement.guide.line2':
    '保存最近涨薪日和最近涨薪额后，也会同步反映到涨薪履历。录错的履历可以从“履历”里删除。',
  'pages.accounting.salaryManagement.modal.guide.title': '保存前，请先确认本次要更新的内容。',
  'pages.accounting.salaryManagement.modal.guide.line1':
    '如果只是修正基本工资，请只更新基本工资后再保存。',
  'pages.accounting.salaryManagement.modal.guide.line2':
    '输入最近涨薪日和最近涨薪额后，系统也会把同样内容反映到涨薪履历。',
  'pages.accounting.salaryManagement.modal.guide.line3':
    '误登记的涨薪履历，可以在保存后从“履历”画面中删除。',
  'pages.accounting.salaryManagement.field.currentSalary.extra':
    '输入当前基本工资。即使只是单纯修正，不是登记涨薪，也请在这里更新。',
  'pages.accounting.salaryManagement.field.lastRaiseDate.extra':
    '需要登记最近一次涨薪日期时填写。保存后会反映到履历。',
  'pages.accounting.salaryManagement.field.lastRaiseAmount.extra':
    '输入最近一次涨薪金额。和最近涨薪日一起保存时，会反映到履历。',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate.extra':
    '如果已经确定下次涨薪计划，请填写这个日期。',
  'pages.accounting.salaryManagement.history.guide.line1':
    '最新的履历会显示在最上面。录错的履历可以直接删除。',
  'pages.accounting.salaryManagement.history.guide.line2':
    '删除履历后，列表中的最新工资信息也会按剩余履历重新计算。',
  'pages.accounting.salaryManagement.cost.outsideEmployment': '对象月份不在职',
  'pages.accounting.salaryManagement.cost.missingBaseSalary': '未登记基本工资',
  'pages.accounting.salaryManagement.cost.reviewRequired': '需要确认',
  'pages.accounting.salaryManagement.cost.departureDateRequired': '离职日期未填写',
  'pages.accounting.salaryManagement.cost.departureDateRequiredHelp':
    '停用账号未填写离职日期，请核对所选月份的在职情况和成本，不能用0或10万固定成本代替。',
  'pages.accounting.salaryManagement.cost.settlementReview': '结算待确认',
  'pages.accounting.salaryManagement.cost.settlementReviewHelp':
    '在职期间外存在案件收入或特别津贴，请核对该月结算，不自动计入当前工资或10万固定成本。',
  'pages.accounting.salaryManagement.cost.rateNotConfigured': '费率未设置',
  'pages.accounting.salaryManagement.cost.breakdownTitle': '公司额外负担预估明细',
  'pages.accounting.salaryManagement.cost.healthStandard': '健康保险标准报酬月额',
  'pages.accounting.salaryManagement.cost.pensionStandard': '厚生年金标准报酬月额',
  'pages.accounting.salaryManagement.cost.health': '健康保险',
  'pages.accounting.salaryManagement.cost.pension': '厚生年金',
  'pages.accounting.salaryManagement.cost.employment': '雇佣保险',
  'pages.accounting.salaryManagement.cost.workersComp': '劳灾保险',
  'pages.accounting.salaryManagement.cost.childRelated': '育儿相关负担',
  'pages.accounting.salaryManagement.cost.childRelatedDetail':
    '儿童育儿支援金 {support} / 儿童育儿拠出金 {contribution}',
  'pages.accounting.salaryManagement.cost.care': '介护保险',
  'pages.interviewList.filter.category': '面接状态',
  'pages.interviewList.filter.scheduled': '已有面接安排',
  'pages.interviewList.filter.pending': '结果保留',
  'pages.interviewList.filter.pass': '合格',
  'pages.interviewList.filter.fail': '不合格',
  'pages.interviewList.column.sequenceNo': '编号',
  'pages.interviewList.column.interviewScheduled': '面接予定',
  'pages.interviewList.column.totalScore': '综合分',
  'pages.interviewList.column.interviewResult': '结果',
  'pages.interviewList.column.attendanceStatus': '入社情况',
  'pages.interviewList.column.pic': '担当者',
  'pages.interviewList.chart.title': '按应募日统计的月度人数',
  'pages.interviewList.chart.subtitle': '反映当前检索与筛选条件',
  'pages.interviewList.chart.month': '应募月份',
  'pages.interviewList.chart.count': '人数',
  'pages.interviewList.chart.countUnit': '人',
  'pages.interviewList.chart.empty': '没有可显示的应募日数据。',
  'pages.interviewList.title': '面试情报一览',
  'pages.interviewList.create': '新規登录',
  'pages.interviewList.reload': '重新加载',
  'pages.interviewList.search.button': '搜索',
  'pages.interviewList.search.placeholder': '候选人姓名 / 应募职种 / 应募经路 / PIC 搜索',
  'pages.interviewList.search.result': '搜索结果',
  'pages.interviewList.search.countUnit': '件',
  'pages.interviewList.filter.all': '全部',
  'pages.interviewList.filter.applicationYear': '应募年',
  'pages.interviewList.filter.applicationMonth': '应募月',
  'pages.interviewList.filter.monthSuffix': '月',
  'pages.interviewList.filter.status': '选考&面试&测试状态',
  'pages.interviewList.filter.appliedPosition': '应募职种',
  'pages.interviewList.filter.sourceChannel': '应募经路',
  'pages.interviewList.filter.position.it': 'it技术职',
  'pages.interviewList.filter.position.sales': '营业职',
  'pages.interviewList.filter.position.office': '事务职',
  'pages.interviewList.filter.source.ijob': 'ijob',
  'pages.interviewList.filter.source.referral': '介绍',
  'pages.interviewList.filter.source.xiaohongshu': '小红书',
  'pages.interviewList.filter.source.other': '其他',
  'pages.interviewList.filter.status.screeningPass': '选考合格',
  'pages.interviewList.filter.status.screeningFail': '选考落选',
  'pages.interviewList.filter.status.screeningPending': '选考保留',
  'pages.interviewList.filter.status.interviewScheduled': '面试预定',
  'pages.interviewList.filter.status.firstPass': '一面合格',
  'pages.interviewList.filter.status.firstFail': '一面落选',
  'pages.interviewList.filter.status.firstPending': '一面保留',
  'pages.interviewList.filter.status.testInProgress': '测试进行中',
  'pages.interviewList.filter.status.testPass': '测试合格',
  'pages.interviewList.filter.status.testFail': '测试落选',
  'pages.interviewList.column.listNo': 'No.',
  'pages.interviewList.column.candidateName': '候选人姓名',
  'pages.interviewList.column.applicationDate': '应募日',
  'pages.interviewList.column.appliedPosition': '应募职种',
  'pages.interviewList.column.sourceChannel': '应募经路',
  'pages.interviewList.column.screeningScore': '结果分数（选考）',
  'pages.interviewList.column.screeningResult': '选考结果',
  'pages.interviewList.column.interviewStatus': '面试状态',
  'pages.interviewList.column.interviewDate': '面试日',
  'pages.interviewList.column.interviewForm': '面试形式',
  'pages.interviewList.column.firstInterviewScore': '结果分数（一面）',
  'pages.interviewList.column.firstInterviewResult': '面试结果（一面）',
  'pages.interviewList.column.action': '操作',
  'pages.interviewList.modal.createTitle': '新增面试情报',
  'pages.interviewList.modal.editTitle': '编辑面试情报',
  'pages.interviewList.section.basic': '基本情况',
  'pages.interviewList.section.screening': '初期选考',
  'pages.interviewList.section.interview': '面试情况',
  'pages.interviewList.section.followup': '结果通知与跟进',
  'pages.interviewList.field.sequenceNo': '序号',
  'pages.interviewList.field.applicationDate': '应募日',
  'pages.interviewList.field.candidateName': '候选人姓名',
  'pages.interviewList.field.appliedPosition': '应募职种',
  'pages.interviewList.field.sourceChannel': '应募经路',
  'pages.interviewList.field.pic': 'PIC',
  'pages.interviewList.field.skillMatchLevel': '技能匹配度',
  'pages.interviewList.field.experienceAssessment': '经验评价',
  'pages.interviewList.field.japaneseAssessment': '日语评价',
  'pages.interviewList.field.visaType': 'VISA种类',
  'pages.interviewList.field.interviewScheduled': '面试预定',
  'pages.interviewList.field.initialScreeningRemarks': '初筛备注',
  'pages.interviewList.field.attendanceStatus': '入社状态',
  'pages.interviewList.field.interviewDate': '面试日',
  'pages.interviewList.field.interviewForm': '面试形式',
  'pages.interviewList.field.skillEvaluation': '技能评价',
  'pages.interviewList.field.motivationEvaluation': '动机评价',
  'pages.interviewList.field.japaneseEvaluation': '日语评价',
  'pages.interviewList.field.attitudeEvaluation': '态度评价',
  'pages.interviewList.field.totalScore': '综合分',
  'pages.interviewList.field.interviewResult': '面试结果',
  'pages.interviewList.field.interviewRemarks': '面试备注',
  'pages.interviewList.field.resultNotifyDate': '结果通知日',
  'pages.interviewList.field.followupRemarks': '跟进备注',
  'pages.interviewList.option.autoSequence': '新增时自动编号',
  'pages.interviewList.option.unscheduled': '未设定',
  'pages.interviewList.option.scheduled': '已预定',
  'pages.interviewList.option.online': 'online',
  'pages.interviewList.option.offline': 'offline',
  'pages.interviewList.option.pending': '保留',
  'pages.interviewList.option.pass': '合格',
  'pages.interviewList.option.fail': '落选',
  'pages.interviewList.action.edit': '编辑',
  'pages.interviewList.action.delete': '删除',
  'pages.interviewList.action.save': '保存',
  'pages.interviewList.action.cancel': '取消',
  'pages.interviewList.confirm.delete': '确定删除这条面试信息吗？',
  'pages.interviewList.validation.candidateName': '请输入候选人姓名。',
  'pages.interviewList.msg.loadFailed': '读取面试信息失败。',
  'pages.interviewList.msg.createSuccess': '面试信息已新增。',
  'pages.interviewList.msg.updateSuccess': '面试信息已更新。',
  'pages.interviewList.msg.saveFailed': '保存面试信息失败。',
  'pages.interviewList.msg.deleteSuccess': '面试信息已删除。',
  'pages.interviewList.msg.deleteFailed': '删除面试信息失败。',
  'pages.interviewList.msg.rollbackToScreeningSuccess': '面试信息已退回履历书选考。',
  'pages.interviewList.msg.rollbackToScreeningFailed': '退回履历书选考失败。',

  'pages.interviewList.calendar.title': '面试日历',
  'pages.interviewList.calendar.firstInterview': '一次面试',
  'pages.interviewList.calendar.testPeriod': '测试期间',
  'pages.interviewList.calendar.noInterviews': '没有面试安排',
  'pages.interviewList.calendar.noUpcoming': '没有后续安排',
  'pages.interviewList.calendar.countUnit': '件',
  'pages.interviewList.calendar.more': '件',
  'pages.interviewList.calendar.upcoming': '后续安排',
  'pages.interviewList.calendar.button': '面试日历',
  // Account Management Page
  'pages.accountManagement.accountId': '账号ID',
  'pages.accountManagement.email': '邮箱',
  'pages.accountManagement.email.placeholder': '请输入邮箱地址',
  'pages.accountManagement.emailInvalid': '请输入有效的邮箱地址。',
  'pages.accountManagement.emailIsVerified': '邮箱验证',
  'pages.accountManagement.phoneNumber': '手机号码',
  'pages.accountManagement.phoneNumber.placeholder': '例：090-1234-5678',
  'pages.accountManagement.phoneNumberInvalid': '请输入有效的电话号码。',
  'pages.accountManagement.phoneIsVerified': '手机验证',
  'pages.accountManagement.operation': '操作',
  'pages.accountManagement.update': '编辑',
  'pages.accountManagement.update.process': '账号更新中...',
  'pages.accountManagement.update.done': '账号已更新。',
  'pages.accountManagement.update.failed': '账号更新失败。',
  'pages.accountManagement.accountName': '账号名称',
  'pages.accountManagement.accountName.placeholder': '请输入账号名称',
  'pages.accountManagement.account.required': '请输入账号名称。',
  'pages.accountManagement.account.accountNameLength': '账号名称请输入6〜18个字符。',
  'pages.accountManagement.account.accountNameInvalid':
    '账号名称必须以英文字母开头，且只能使用半角英数字。',
  'pages.accountManagement.password': '密码',
  'pages.accountManagement.password.placeholder': '请输入密码',
  'pages.accountManagement.password.required': '请输入密码。',
  'pages.accountManagement.password.passwordLength': '密码请输入6〜18个字符。',
  'pages.accountManagement.password.passwordInvalid': '密码只能使用半角英数字。',
  'pages.accountManagement.passwordReset': '重置密码',
  'pages.accountManagement.passwordReset.process': '密码重置中...',
  'pages.accountManagement.passwordReset.done': '密码已重置。',
  'pages.accountManagement.passwordReset.doneWithNotice':
    '密码已重置为123456。请提醒用户尽快修改密码。',
  'pages.accountManagement.passwordReset.failed': '密码重置失败。',
  'pages.accountManagement.passwordReset.confirmTitle': '确定要重置密码吗？',
  'pages.accountManagement.passwordReset.confirmDescription': '密码将重置为初始值123456。',
  'pages.accountManagement.delete': '删除',
  'pages.accountManagement.delete.process': '账号删除中...',
  'pages.accountManagement.delete.done': '账号已删除。',
  'pages.accountManagement.delete.failed': '账号删除失败。',
  'pages.accountManagement.delete.confirmTitle': '确定要删除账号吗？',
  'pages.accountManagement.delete.currentAccountDenied': '不能删除当前登录账号。',
  'pages.accountManagement.delete.batchCurrentSkipped': '当前登录账号已从删除对象中排除。',
  'pages.accountManagement.delete.batchConfirmTitle': '确定删除选中的账号吗？',
  'pages.accountManagement.delete.batchConfirmCount': '删除对象',
  'pages.accountManagement.delete.batchConfirmMore': '其他',
  'pages.accountManagement.searchList': '账号列表',
  'pages.accountManagement.serachList': '账号列表',
  'pages.accountManagement.create': '新建账号',
  'pages.accountManagement.create.process': '账号创建中...',
  'pages.accountManagement.create.done': '账号已创建。',
  'pages.accountManagement.create.failed': '账号创建失败。',
  'pages.accountManagement.selected': '已选择账号',
  'pages.accountManagement.selectedDelete': '删除选中账号',
  'pages.accountManagement.roleSet': '编辑角色',
  'pages.accountManagement.roleSet.view': '角色加载中...',
  'pages.accountManagement.roleSet.title': '账号角色编辑',
  'pages.accountManagement.roleSet.roles': '选择角色',
  'pages.accountManagement.roleSet.selectedCount': '已选角色',
  'pages.accountManagement.roleSet.empty': '没有可设置的角色。',
  'pages.accountManagement.roleSet.emptyConfirmTitle': '确定不设置任何角色并保存吗？',
  'pages.accountManagement.roleSet.emptyConfirmContent':
    '移除所有角色后，该账号可能无法访问任何页面。',
  'pages.accountManagement.roleSetting.process': '角色信息更新中...',
  'pages.accountManagement.roleSetting.done': '角色信息已更新。',
  'pages.accountManagement.roleSetting.failed': '角色信息更新失败。',
  'pages.accountManagement.verified': '已验证',
  'pages.accountManagement.unverified': '未验证',
  'pages.accountManagement.countUnit': '件',
  'pages.accountManagement.action.save': '保存',
  'pages.accountManagement.action.cancel': '取消',
  'pages.accountManagement.modal.createTitle': '新建账号',
  'pages.accountManagement.modal.editTitle': '编辑账号',
  'pages.accountManagement.modal.accountNameReadonly': '账号名称创建后不可修改。',
  'pages.accountManagement.search.button': '搜索',
  'pages.accountManagement.search.placeholder': '按账号ID / 账号名称 / 邮箱 / 手机号码搜索',
  'pages.accountManagement.search.result': '搜索结果',
  'pages.accountManagement.reload': '重新加载',
  'pages.accountManagement.load.failed': '账号列表获取失败。',
  'pages.accountManagement.filter.status': '状态',
  'pages.accountManagement.filter.all': '全部',
  'pages.accountManagement.filter.emailUnverified': '邮箱未验证',
  'pages.accountManagement.filter.phoneUnverified': '手机未验证',
  'pages.accountManagement.accountStatus.title': '账号状态',
  'pages.accountManagement.accountStatus.active': '使用中',
  'pages.accountManagement.accountStatus.disabled': '停止中',

  // 固定资产管理
  'pages.fixedAssets.title': '固定资产一览',
  'pages.fixedAssets.countUnit': '件',
  'pages.fixedAssets.group.sameName': '同名资产',
  'pages.fixedAssets.group.assetCount': '{count}件',
  'pages.fixedAssets.group.mixed': '多个',
  'pages.fixedAssets.group.expandForDetail': '展开确认',
  'pages.fixedAssets.group.expandForAction': '展开后操作',
  'pages.fixedAssets.group.countSummary': '{groups}组 / {assets}件',
  'pages.fixedAssets.filter.all': '全部',
  'pages.fixedAssets.filter.category': '资产分类',
  'pages.fixedAssets.filter.status': '资产状态',
  'pages.fixedAssets.filter.location': '所在地',
  'pages.fixedAssets.filter.clear': '清空条件',
  'pages.fixedAssets.search.placeholder': '按资产名 / 资产编号 / 品牌 / 备注搜索',
  'pages.fixedAssets.search.button': '搜索',
  'pages.fixedAssets.action.create': '新建登记',
  'pages.fixedAssets.action.edit': '编辑',
  'pages.fixedAssets.action.copy': '复制',
  'pages.fixedAssets.action.delete': '删除',
  'pages.fixedAssets.action.save': '保存',
  'pages.fixedAssets.action.bulkSave': '一括保存',
  'pages.fixedAssets.action.copyAdd': '复制追加',
  'pages.fixedAssets.action.cancel': '取消',
  'pages.fixedAssets.action.reload': '重新加载',
  'pages.fixedAssets.action.add': '追加',
  'pages.fixedAssets.action.update': '更新',
  'pages.fixedAssets.action.categoryManagement': '分类管理',
  'pages.fixedAssets.action.addPart': '追加部件',
  'pages.fixedAssets.action.addUsageHistory': '追加使用履历',
  'pages.fixedAssets.column.assetNumber': '资产编号',
  'pages.fixedAssets.column.assetName': '资产名',
  'pages.fixedAssets.column.category': '分类',
  'pages.fixedAssets.column.brandOs': '品牌 / OS',
  'pages.fixedAssets.column.purchaseAmount': '购买金额',
  'pages.fixedAssets.column.purchaseDate': '购买日',
  'pages.fixedAssets.column.useDuration': '使用时间',
  'pages.fixedAssets.column.location': '所在地',
  'pages.fixedAssets.column.currentUser': '使用者',
  'pages.fixedAssets.column.stockInDate': '入库日',
  'pages.fixedAssets.column.brand': '品牌',
  'pages.fixedAssets.column.status': '状态',
  'pages.fixedAssets.column.remarks': '备注',
  'pages.fixedAssets.column.action': '操作',
  'pages.fixedAssets.modal.createTitle': '固定资产新建登记',
  'pages.fixedAssets.modal.editTitle': '固定资产编辑',
  'pages.fixedAssets.modal.copyTitle': '固定资产复制追加',
  'pages.fixedAssets.section.basic': '基本信息',
  'pages.fixedAssets.section.parts': '部件',
  'pages.fixedAssets.section.assetState': '资产状态',
  'pages.fixedAssets.section.usageHistory': '使用履历',
  'pages.fixedAssets.section.remarks': '备注',
  'pages.fixedAssets.field.assetName': '资产名',
  'pages.fixedAssets.field.majorCategory': '大分类',
  'pages.fixedAssets.field.subCategory': '小分类',
  'pages.fixedAssets.field.brand': '品牌',
  'pages.fixedAssets.field.purchaseAmount': '购买金额',
  'pages.fixedAssets.field.purchaseDate': '购买日',
  'pages.fixedAssets.field.location': '所在地',
  'pages.fixedAssets.field.assetStatus': '资产状态',
  'pages.fixedAssets.field.partName': '部件名',
  'pages.fixedAssets.field.quantity': '数量',
  'pages.fixedAssets.field.registrationQuantity': '登记数量',
  'pages.fixedAssets.field.temporaryNumber': '临时编号',
  'pages.fixedAssets.field.userName': '使用者',
  'pages.fixedAssets.field.useStartDate': '使用开始日',
  'pages.fixedAssets.field.useEndDate': '使用结束日',
  'pages.fixedAssets.field.stockInDate': '入库日',
  'pages.fixedAssets.field.usePeriod': '使用期间',
  'pages.fixedAssets.placeholder.assetName': '例：MacBook Pro 14英寸',
  'pages.fixedAssets.placeholder.majorCategory': '请选择大分类',
  'pages.fixedAssets.placeholder.subCategory': '请选择小分类',
  'pages.fixedAssets.placeholder.noSubCategory': '无小分类',
  'pages.fixedAssets.placeholder.brand': 'Apple / Dell / ELECOM 等',
  'pages.fixedAssets.placeholder.os': 'Windows 11 / macOS 等',
  'pages.fixedAssets.placeholder.location': '请选择所在地',
  'pages.fixedAssets.placeholder.status': '请选择状态',
  'pages.fixedAssets.placeholder.partName': '部件名',
  'pages.fixedAssets.placeholder.userName': '从员工候选中选择，或直接输入',
  'pages.fixedAssets.placeholder.currentUser': '留空表示当前使用中',
  'pages.fixedAssets.placeholder.remarks': '可输入购买金额、保修期限、管理备注等。',
  'pages.fixedAssets.validation.assetNameRequired': '请输入资产名。',
  'pages.fixedAssets.validation.majorCategoryRequired': '请选择大分类。',
  'pages.fixedAssets.validation.purchaseAmountRequired': '请输入购买金额。',
  'pages.fixedAssets.validation.purchaseDateRequired': '请选择购买日。',
  'pages.fixedAssets.validation.stockInDateRequired': '请选择入库日。',
  'pages.fixedAssets.validation.registrationQuantityRequired': '请输入登记数量。',
  'pages.fixedAssets.validation.currentUserSingle': '当前使用中的使用者只能设置 1 名。',
  'pages.fixedAssets.validation.locationRequired': '请选择所在地。',
  'pages.fixedAssets.confirm.deleteAsset': '确定要删除这个固定资产吗？',
  'pages.fixedAssets.confirm.deleteCategory': '确定要删除这个分类吗？',
  'pages.fixedAssets.message.loadFailed': '固定资产信息获取失败。',
  'pages.fixedAssets.message.detailLoadFailed': '固定资产详情获取失败。',
  'pages.fixedAssets.message.saved': '已保存。',
  'pages.fixedAssets.message.saveFailed': '固定资产保存失败。',
  'pages.fixedAssets.message.deleted': '已删除。',
  'pages.fixedAssets.message.deleteFailed': '固定资产删除失败。',
  'pages.fixedAssets.message.categorySaved': '分类已保存。',
  'pages.fixedAssets.message.categorySaveFailed': '分类保存失败。',
  'pages.fixedAssets.message.categoryDeleted': '分类已删除。',
  'pages.fixedAssets.message.categoryDeleteFailed': '分类删除失败。',
  'pages.fixedAssets.status.running': '运行中',
  'pages.fixedAssets.status.idle': '未运行',
  'pages.fixedAssets.status.repairing': '修理中',
  'pages.fixedAssets.status.disposalPlanned': '计划废弃',
  'pages.fixedAssets.status.disposed': '已废弃',
  'pages.fixedAssets.location.warehouse': '仓库',
  'pages.fixedAssets.location.development': '开发部',
  'pages.fixedAssets.location.ec': 'EC部',
  'pages.fixedAssets.location.sales': '营业部',
  'pages.fixedAssets.location.hr': '人事部',
  'pages.fixedAssets.location.generalAffairs': '总务部',
  'pages.fixedAssets.location.accounting': '经理部',
  'pages.fixedAssets.location.other': '其他',
  'pages.fixedAssets.category.modalTitle': '固定资产分类管理',
  'pages.fixedAssets.category.addTitle': '追加分类',
  'pages.fixedAssets.category.editTitle': '编辑分类',
  'pages.fixedAssets.category.addMajorTitle': '追加大分类',
  'pages.fixedAssets.category.addSubTitle': '追加小分类',
  'pages.fixedAssets.category.listTitle': '分类一览',
  'pages.fixedAssets.category.addMajorAction': '追加大分类',
  'pages.fixedAssets.category.addSubAction': '在选中分类下追加小分类',
  'pages.fixedAssets.category.empty': '暂无分类。',
  'pages.fixedAssets.category.message.noParentCategory': '请先追加大分类。',
  'pages.fixedAssets.category.column.name': '分类名',
  'pages.fixedAssets.category.column.sortOrder': '显示顺序',
  'pages.fixedAssets.category.column.activeFlag': '状态',
  'pages.fixedAssets.category.parentCategory': '父分类',
  'pages.fixedAssets.category.parentPlaceholder': '大分类时无需选择',
  'pages.fixedAssets.category.parentSelectPlaceholder': '请选择父分类',
  'pages.fixedAssets.category.type': '分类类型',
  'pages.fixedAssets.category.majorType': '追加大分类',
  'pages.fixedAssets.category.subType': '追加小分类',
  'pages.fixedAssets.category.majorTypeHelp': '作为大分类追加。需要填写用于资产编号的分类Code。',
  'pages.fixedAssets.category.subTypeHelp': '将在所选大分类下面追加小分类。',
  'pages.fixedAssets.category.name': '分类名',
  'pages.fixedAssets.category.code': '分类Code',
  'pages.fixedAssets.category.codePlaceholder': '例：IT',
  'pages.fixedAssets.category.sortOrder': '显示顺序',
  'pages.fixedAssets.category.activeFlag': '有效状态',
  'pages.fixedAssets.category.active': '有效',
  'pages.fixedAssets.category.inactive': '无效',
  'pages.fixedAssets.category.backToCreate': '返回新建输入',
  'pages.fixedAssets.category.validation.parentRequired': '请选择父分类。',
  'pages.fixedAssets.category.validation.nameRequired': '请输入分类名。',
  'pages.fixedAssets.category.validation.codeRequired': '请输入分类Code。',
  'pages.fixedAssets.category.validation.codePattern': '请输入 2～6 位大写英数字。',

  // 首页・等级积分
  'pages.home.common.none': '-',
  'pages.home.common.pointSuffix': '积分',
  'pages.home.common.minutesSuffix': '分',
  'pages.home.notice.title': '社内公告・通知',
  'pages.home.notice.noUnread': '无未读',
  'pages.home.notice.unreadCount': '未读 {count} 件',
  'pages.home.notice.unread': '未读',
  'pages.home.notice.important': '重要',
  'pages.home.notice.viewAll': '前往一览',
  'pages.home.notice.noPublished': '暂无公开中的通知',
  'pages.home.notice.unreadModalTitle': '未读公告',
  'pages.home.notice.noUnreadNotice': '暂无未读公告',
  'pages.home.notice.publishDate': '发布日期: {date}',
  'pages.home.growth.level': '等级 {level}',
  'pages.home.growth.experience': '经验值 {current}/{next}',
  'pages.home.growth.points': '积分',
  'pages.home.growth.todayUsage': '今日使用',
  'pages.home.growth.usagePoints': '使用积分',
  'pages.home.growth.gamePoints': '游戏积分',
  'pages.home.growth.exchangeHint': '通过使用时间和游戏挑战积累积分，可兑换称号和勋章。',
  'pages.home.reward.type.title': '称号',
  'pages.home.reward.type.badge': '勋章',
  'pages.home.reward.type.icon': '图标',
  'pages.home.reward.type.frame': '边框',
  'pages.home.reward.type.reward': '奖励',
  'pages.home.reward.descriptionLabel': '说明:',
  'pages.home.reward.noEquippedBadgeDescription': '暂无已装备勋章说明。',
  'pages.home.reward.titleNotSet': '未设置称号',
  'pages.home.reward.badgeNotSet': '未设置勋章',
  'pages.home.reward.exchangeSuccess': '奖励兑换成功。',
  'pages.home.reward.exchangeFailed': '奖励兑换失败。',
  'pages.home.reward.equipSuccess': '奖励装备成功。',
  'pages.home.reward.equipFailed': '奖励装备失败。',
  'pages.home.reward.exchangeButton': '积分兑换',
  'pages.home.reward.exchangeDrawerTitle': '积分兑换',
  'pages.home.reward.currentPoints': '当前积分',
  'pages.home.reward.empty': '暂无可兑换奖励',
  'pages.home.reward.equipped': '装备中',
  'pages.home.reward.equip': '装备',
  'pages.home.reward.exchange': '兑换',
  'pages.home.game.selectionTitle': '游戏选择',
  'pages.home.game.modalFallbackTitle': '游戏',
  'pages.home.game.raiden.title': '雷电游戏',
  'pages.home.game.raiden.description': '用短时间切换专注力的射击小游戏。',
  'pages.home.game.frogWords.title': '青蛙过河・单词游戏',
  'pages.home.game.frogWords.description': '输入日中 IT 词汇，让青蛙一步步过河。',
  'pages.home.game.scoreGained': '{game} 分数已提交，获得 {points} 积分。',
  'pages.home.game.scoreRecorded': '{game} 分数已记录，今日没有追加积分。',
  'pages.home.game.scoreSubmitFailed': '{game} 分数提交失败。',
  'pages.home.game.leaderboardButton': '排行榜',
  'pages.home.game.leaderboardTitle': '{game} 排行榜',
  'pages.home.game.leaderboardFallbackTitle': '排行榜',
  'pages.home.game.leaderboardScore': '累计积分: {points} / 最高分: {bestScore}',
  'pages.home.game.leaderboardNoRank': '榜上无名，需要努力。',
  'pages.home.game.leaderboardMyRank': '当前第 {rank} 名。累计积分: {points}',
  'pages.home.game.leaderboardEmpty': '暂无排行榜数据。',
  'pages.home.game.leaderboardLoadFailed': '排行榜取得失败。',
  'pages.home.reward.gitApostle.name': 'Git 使徒',
  'pages.home.reward.gitApostle.description': '适合熟悉 Git 运用的人使用的称号。',
  'pages.home.reward.testPaladin.name': '测试圣骑士',
  'pages.home.reward.testPaladin.description': '守护测试质量的人专属勋章。',
  'pages.home.reward.raidenPilot.name': '雷电飞行员',
  'pages.home.reward.raidenPilot.description': '适合挑战雷电游戏的人使用的图标。',
  'pages.home.reward.blueFrame.name': '蓝色边框',
  'pages.home.reward.blueFrame.description': '用于稍微装饰首页的个人边框。',
  'pages.home.reward.bugHunter.name': 'Bug 猎人',
  'pages.home.reward.bugHunter.description': '适合不放过小缺陷的人使用的称号。',
  'pages.home.reward.sqlSamurai.name': 'SQL 武士',
  'pages.home.reward.sqlSamurai.description': '适合静静斩断条件与连接的人使用的称号。',
  'pages.home.reward.diffWizard.name': '差分魔术师',
  'pages.home.reward.diffWizard.description': '适合在 Review 中读懂差分意图的人使用的称号。',
  'pages.home.reward.morningSprinter.name': '晨间冲刺者',
  'pages.home.reward.morningSprinter.description': '适合从清晨开始轻快推进任务的人使用的称号。',
  'pages.home.reward.midnightDeployGuardian.name': '深夜发布守护者',
  'pages.home.reward.midnightDeployGuardian.description': '在夜晚的安静中守护上线的人专属称号。',
  'pages.home.reward.specTraveler.name': '规格书旅人',
  'pages.home.reward.specTraveler.description': '适合能在规格森林中不迷路前进的人使用的称号。',
  'pages.home.reward.commitCraftsman.name': '提交工匠',
  'pages.home.reward.commitCraftsman.description': '适合认真堆叠每一次变更的人使用的称号。',
  'pages.home.reward.bugDetective.name': '缺陷侦探',
  'pages.home.reward.bugDetective.description': '适合从现象一路追到原因的人使用的称号。',
  'pages.home.reward.raidenAce.name': '雷电王牌',
  'pages.home.reward.raidenAce.description': '适合在雷电游戏中驰骋天空的人使用的称号。',
  'pages.home.reward.raidenBulletApprentice.name': '弹幕见习生',
  'pages.home.reward.raidenBulletApprentice.description':
    '适合刚刚开始接受弹幕洗礼的人使用的称号。',
  'pages.home.reward.raidenRookie.name': '雷电新人',
  'pages.home.reward.raidenRookie.description': '适合有勇气按下出击按钮的人使用的称号。',
  'pages.home.reward.skyDogfighter.name': '青空缠斗者',
  'pages.home.reward.skyDogfighter.description': '适合在蓝天中灵活周旋的人使用的称号。',
  'pages.home.reward.lowAltitudeDodger.name': '低空回避名人',
  'pages.home.reward.lowAltitudeDodger.description': '适合总能在低空闪避弹幕的人使用的称号。',
  'pages.home.reward.laserStraightShot.name': '激光直线派',
  'pages.home.reward.laserStraightShot.description': '适合不迷路、一路打穿的人使用的称号。',
  'pages.home.reward.cloudSniper.name': '云间狙击手',
  'pages.home.reward.cloudSniper.description': '适合能从云缝中精准命中的人使用的称号。',
  'pages.home.reward.bossBreath.name': 'Boss前深呼吸',
  'pages.home.reward.bossBreath.description': '适合 Boss 战前会先冷静一下的人使用的称号。',
  'pages.home.reward.noDamagePrayer.name': '无伤祈愿兵',
  'pages.home.reward.noDamagePrayer.description': '适合一边祈祷无伤一边冲进去的人使用的称号。',
  'pages.home.reward.thunderAce.name': '雷鸣王牌',
  'pages.home.reward.thunderAce.description': '适合伴随雷鸣不断刷新分数的人使用的称号。',
  'pages.home.reward.airspaceCommander.name': '空域压制队长',
  'pages.home.reward.airspaceCommander.description': '适合面对满屏敌人也不慌的队长使用的称号。',
  'pages.home.reward.lilyPadJumper.name': '荷叶跳跃者',
  'pages.home.reward.lilyPadJumper.description': '适合和青蛙一起踩着荷叶前进的人使用的称号。',
  'pages.home.reward.wordHopper.name': '单词蹦蹦太',
  'pages.home.reward.wordHopper.description': '适合看到单词就能反射性作答的人使用的称号。',
  'pages.home.reward.jpCnWordFerryman.name': '日中词语摆渡人',
  'pages.home.reward.jpCnWordFerryman.description': '适合在日语和中文之间架桥的人使用的称号。',
  'pages.home.reward.translationRiverGuide.name': '翻译河流向导',
  'pages.home.reward.translationRiverGuide.description': '适合在术语之河里带路的人使用的称号。',
  'pages.home.reward.lostParticleRescue.name': '迷路助词救援队',
  'pages.home.reward.lostParticleRescue.description': '适合温柔拯救助词和词尾的人使用的称号。',
  'pages.home.reward.termFishingMaster.name': '术语钓鱼名人',
  'pages.home.reward.termFishingMaster.description': '适合能从记忆池里钓出正确答案的人使用的称号。',
  'pages.home.reward.frogMemoryMaster.name': '青蛙记忆大师',
  'pages.home.reward.frogMemoryMaster.description': '适合比青蛙更快记住单词的人使用的称号。',
  'pages.home.reward.bilingualSkipKing.name': '双语跳跃王',
  'pages.home.reward.bilingualSkipKing.description': '适合轻快跨越两种语言的人使用的称号。',
  'pages.home.reward.wrongAnswerRecovery.name': '错题恢复班',
  'pages.home.reward.wrongAnswerRecovery.description':
    '适合答错后也能立刻迈出下一步的人使用的称号。',
  'pages.home.reward.oppositeBankSage.name': '到达对岸的贤者',
  'pages.home.reward.oppositeBankSage.description':
    '适合把词语一路连到最后一片荷叶的人使用的称号。',
  'pages.home.reward.quietImprover.name': '安静的改善者',
  'pages.home.reward.quietImprover.description': '适合持续积累不起眼改善的人使用的称号。',
  'pages.home.reward.qualityGuardianBadge.name': '质量守护徽章',
  'pages.home.reward.qualityGuardianBadge.description': '表现重视质量姿态的勋章。',
  'pages.home.reward.learningFinisherMedal.name': '学习完走奖章',
  'pages.home.reward.learningFinisherMedal.description': '表彰坚持学完能力的勋章。',
  'pages.home.reward.monthEndAttendanceMaster.name': '月末考勤大师',
  'pages.home.reward.monthEndAttendanceMaster.description': '适合不会忘记月末处理的人使用的勋章。',
  'pages.home.reward.blueLightning.name': '蓝色闪电',
  'pages.home.reward.blueLightning.description': '让首页稍微更利落的图标。',
  'pages.home.reward.coffeeRefueler.name': '咖啡补给机',
  'pages.home.reward.coffeeRefueler.description': '想在专注时间放在身边的图标。',
  'pages.home.reward.keyboardNinja.name': '键盘忍者',
  'pages.home.reward.keyboardNinja.description': '适合享受高速输入的人使用的图标。',
  'pages.home.reward.sakuraFrame.name': '樱花边框',
  'pages.home.reward.sakuraFrame.description': '柔和印象的个人边框。',
  'pages.home.reward.nightShiftFrame.name': '夜勤边框',
  'pages.home.reward.nightShiftFrame.description': '以夜间专注作业为灵感的边框。',
  'pages.home.reward.goldLine.name': '金色线条',
  'pages.home.reward.goldLine.description': '稍微带来特别感的金色系边框。',
  'pages.hrDocument.title': '文件申请',
  'pages.hrDocument.management.title': '文件申请管理',
  'pages.hrDocument.management.listTitle': '申请管理一览',
  'pages.hrDocument.list.title': '申请一览',
  'pages.hrDocument.detail.title': '文件申请详情',
  'pages.hrDocument.status.0': '草稿',
  'pages.hrDocument.status.1': '待审批',
  'pages.hrDocument.status.2': '退回',
  'pages.hrDocument.status.3': '制作中',
  'pages.hrDocument.status.4': '待领取',
  'pages.hrDocument.status.5': '已完成',
  'pages.hrDocument.status.6': '已取消',
  'pages.hrDocument.delivery.download': '系统下载',
  'pages.hrDocument.delivery.pickup': '线下领取',
  'pages.hrDocument.field.requestNo': '申请编号',
  'pages.hrDocument.field.status': '状态',
  'pages.hrDocument.field.applicant': '申请人',
  'pages.hrDocument.field.department': '所属部门',
  'pages.hrDocument.field.documentType': '文件类型',
  'pages.hrDocument.field.quantity': '份数',
  'pages.hrDocument.field.reason': '用途・申请理由',
  'pages.hrDocument.field.destination': '提交对象',
  'pages.hrDocument.field.desiredDate': '希望交付日',
  'pages.hrDocument.field.deliveryMethod': '交付方式',
  'pages.hrDocument.field.notes': '补充说明',
  'pages.hrDocument.field.returnReason': '退回理由',
  'pages.hrDocument.field.cancelReason': '取消理由',
  'pages.hrDocument.field.actions': '操作',
  'pages.hrDocument.action.create': '新建申请',
  'pages.hrDocument.action.edit': '编辑',
  'pages.hrDocument.action.detail': '详情',
  'pages.hrDocument.action.submit': '提交',
  'pages.hrDocument.action.cancel': '取消',
  'pages.hrDocument.action.delete': '删除',
  'pages.hrDocument.action.download': '下载',
  'pages.hrDocument.action.approve': '同意',
  'pages.hrDocument.action.return': '退回',
  'pages.hrDocument.action.ready': '制作完成',
  'pages.hrDocument.action.complete': '交付完成',
  'pages.hrDocument.action.upload': '上传PDF',
  'pages.hrDocument.action.confirm': '确认',
  'pages.hrDocument.action.back': '返回',
  'pages.hrDocument.confirm.submit': '确定提交该申请吗？',
  'pages.hrDocument.confirm.cancel': '确定取消该申请吗？',
  'pages.hrDocument.confirm.delete': '确定物理删除该申请吗？',
  'pages.hrDocument.confirm.approve': '确定同意该申请吗？',
  'pages.hrDocument.confirm.ready': '确定已完成交付准备吗？',
  'pages.hrDocument.confirm.complete': '确定文件已交付吗？',
  'pages.hrDocument.confirm.deleteFile': '确定删除该PDF吗？',
  'pages.hrDocument.confirm.deleteType': '确定删除该文件类型吗？',
  'pages.hrDocument.filter.status': '状态',
  'pages.hrDocument.filter.all': '全部',
  'pages.hrDocument.filter.keyword': '按申请编号、文件类型、理由搜索',
  'pages.hrDocument.filter.managementKeyword': '按申请编号、员工姓名、理由搜索',
  'pages.hrDocument.form.createTitle': '新建文件申请',
  'pages.hrDocument.form.editTitle': '编辑文件申请',
  'pages.hrDocument.files.title': '交付文件',
  'pages.hrDocument.files.empty': '暂无交付文件',
  'pages.hrDocument.history.title': '处理履历',
  'pages.hrDocument.return.title': '退回文件申请',
  'pages.hrDocument.cancel.title': '取消文件申请',
  'pages.hrDocument.type.manage': '文件类型管理',
  'pages.hrDocument.type.create': '新增文件类型',
  'pages.hrDocument.type.edit': '编辑文件类型',
  'pages.hrDocument.type.code': '类型编码',
  'pages.hrDocument.type.name': '类型名称',
  'pages.hrDocument.type.description': '说明',
  'pages.hrDocument.type.order': '显示顺序',
  'pages.hrDocument.type.active': '有效状态',
  'pages.hrDocument.type.enabled': '有效',
  'pages.hrDocument.type.disabled': '停用',
  'pages.hrDocument.msg.loadFailed': '文件申请加载失败。',
  'pages.hrDocument.msg.detailFailed': '申请详情加载失败。',
  'pages.hrDocument.msg.actionFailed': '处理失败。',
  'pages.hrDocument.msg.downloadFailed': '文件下载失败。',
  'pages.hrDocument.msg.saveSuccess': '文件申请已保存。',
  'pages.hrDocument.msg.saveFailed': '保存失败。',
  'pages.hrDocument.msg.submitSuccess': '文件申请已提交。',
  'pages.hrDocument.msg.cancelSuccess': '文件申请已取消。',
  'pages.hrDocument.msg.deleteSuccess': '文件申请已删除。',
  'pages.hrDocument.msg.approveSuccess': '文件申请已同意。',
  'pages.hrDocument.msg.returnSuccess': '文件申请已退回。',
  'pages.hrDocument.msg.readySuccess': '交付准备已完成。',
  'pages.hrDocument.msg.completeSuccess': '文件交付已完成。',
  'pages.hrDocument.msg.uploadSuccess': 'PDF已上传。',
  'pages.hrDocument.msg.uploadFailed': 'PDF上传失败。',
  'pages.hrDocument.msg.fileDeleteSuccess': 'PDF已删除。',
  'pages.hrDocument.msg.typeSaveSuccess': '文件类型已保存。',
  'pages.hrDocument.msg.typeDeleteSuccess': '文件类型已删除。',
  'pages.hrDocument.action.save': '保存',
  'pages.hrDocument.action.register': '登记',
  'pages.hrDocument.action.preview': 'PDF预览',
  'pages.hrDocument.action.generate': '生成PDF',
  'pages.hrDocument.action.generateDeliver': '生成PDF并交付',
  'pages.hrDocument.action.redeliver': '重新交付',
  'pages.hrDocument.confirm.redeliver': '确定重新交付并将下载期限延长7天吗？',
  'pages.hrDocument.confirm.deleteStamp': '确定物理删除这个电子章吗？',
  'pages.hrDocument.type.deliveryMethods': '可用交付方式',
  'pages.hrDocument.type.allowDownload': '在线下载',
  'pages.hrDocument.type.allowPickup': '窗口领取',
  'pages.hrDocument.template.edit': '模板',
  'pages.hrDocument.template.title': '{type} 模板',
  'pages.hrDocument.template.name': '模板名称',
  'pages.hrDocument.template.variables': '自动填充变量（点击插入）',
  'pages.hrDocument.template.body': '模板正文',
  'pages.hrDocument.template.customFields': '生成时补充输入项',
  'pages.hrDocument.template.fieldLabel': '项目名称',
  'pages.hrDocument.template.required': '必填',
  'pages.hrDocument.template.addField': '追加输入项',
  'pages.hrDocument.stamp.manage': '电子章管理',
  'pages.hrDocument.stamp.name': '电子章名称',
  'pages.hrDocument.stamp.fileName': '登记文件',
  'pages.hrDocument.stamp.selectPng': '选择PNG',
  'pages.hrDocument.generate.title': '生成文件PDF',
  'pages.hrDocument.generate.stamp': '电子章',
  'pages.hrDocument.generate.noStamp': '不使用电子章',
  'pages.hrDocument.download.notice': '交付后7天内可重复下载。过期后请联系HR重新交付。',
  'pages.hrDocument.download.expired': '下载期限已过，请联系HR重新交付。',
  'pages.hrDocument.download.expiresAt': '下载期限',
  'pages.hrDocument.download.expiredShort': '已过期',
  'pages.hrDocument.download.countdown': '剩余 {days}天 {hours}小时',
  'pages.hrDocument.msg.templateLoadFailed': '模板读取失败。',
  'pages.hrDocument.msg.templateSaveSuccess': '模板已保存。',
  'pages.hrDocument.msg.templateSaveFailed': '模板保存失败。',
  'pages.hrDocument.msg.stampLoadFailed': '电子章读取失败。',
  'pages.hrDocument.msg.stampSaveFailed': '电子章登记失败。',
  'pages.hrDocument.msg.generateLoadFailed': 'PDF生成信息读取失败。',
  'pages.hrDocument.msg.previewFailed': 'PDF预览生成失败。',
  'pages.hrDocument.msg.generateSuccess': 'PDF已生成并交付。',
  'pages.hrDocument.msg.generateFailed': 'PDF生成或交付失败。',
  'pages.hrDocument.msg.redeliverSuccess': '文件已重新交付。',
  'pages.invoiceList.taxCategory': '税务区分',
  'pages.invoiceList.taxCategory.taxable': '课税',
  'pages.invoiceList.taxCategory.nonTaxable': '非课税',
  'pages.invoiceList.amount.subtotal': '小计',
  'pages.invoiceList.amount.taxableSubtotal': '课税对象金额',
  'pages.invoiceList.amount.nonTaxableSubtotal': '非课税金额',
  'pages.invoiceList.amount.tax': '消费税 10%',
  'pages.invoiceList.amount.total': '合计金额',
  'pages.invoiceList.attendance.totalHours': '当月工作时间',
  'pages.invoiceList.attendance.status': '考勤状态',
  'pages.invoiceList.attendance.status.unsubmitted': '未提交',
  'pages.invoiceList.attendance.status.pending': '待审批',
  'pages.invoiceList.attendance.status.approved': '已审批',
  'pages.invoiceList.attendance.export': '考勤导出',
  'pages.invoiceList.attendance.export.excel': '导出Excel',
  'pages.invoiceList.attendance.export.pdf': '导出PDF',
  'pages.invoiceList.attendance.export.noTargets': '没有可导出的考勤人员。',
  'pages.accounting.dashboard.title': '财务仪表盘',
  'pages.accounting.dashboard.subtitle':
    '从发票收入中扣除合同员工与正式员工人力总成本后的概算结果。',
  'pages.accounting.dashboard.monthSuffix': '月',
  'pages.accounting.dashboard.mode.forecast': '预计',
  'pages.accounting.dashboard.tax.excluded': '未税',
  'pages.accounting.dashboard.tax.included': '含税',
  'pages.accounting.dashboard.metric.revenue': '发票收入',
  'pages.accounting.dashboard.metric.personnelCost': '人力总成本',
  'pages.accounting.dashboard.metric.profit': '扣除人力成本后概算利润',
  'pages.accounting.dashboard.section.monthly': '{month}月',
  'pages.accounting.dashboard.section.annual': '{year}年合计',
  'pages.accounting.dashboard.note.selectedMonth': '所选月份',
  'pages.accounting.dashboard.note.salaryFormula': '基本工资 + 特别津贴 + 公司负担预计额',
  'pages.accounting.dashboard.note.annual': '1月至12月合计',
  'pages.accounting.dashboard.note.margin': '利润率 {margin}',
  'pages.accounting.dashboard.table.title': '12个月明细',
  'pages.accounting.dashboard.table.month': '月份',
  'pages.accounting.dashboard.table.baseSalary': '基本工资',
  'pages.accounting.dashboard.table.specialAllowance': '特别津贴',
  'pages.accounting.dashboard.table.employerBurden': '公司负担预计额',
  'pages.accounting.dashboard.table.margin': '利润率',
  'pages.accounting.dashboard.table.warningCount': '待确认人数',
  'pages.accounting.dashboard.status.review': '待确认',
  'pages.accounting.dashboard.warning.title': '部分月份需要确认计算条件',
  'pages.accounting.dashboard.warning.description':
    '基本工资、生日或费率缺失、离职日期未填写或在职期间外存在结算的月份，成本与利润显示待确认。现在账号停用不影响历史在职月份的计算。',
  'pages.accounting.dashboard.message.loadFailed': '财务仪表盘加载失败。',
  'pages.attendanceInput.submitConfirm.title': '考勤提交确认（{year}年{month}月）',
  'pages.attendanceInput.submitConfirm.message': '请先补全当月考勤信息后再提交，并确认没有遗漏。',
  'pages.attendanceInput.submitConfirm.editLock': '提交后将无法编辑。',
  'pages.attendanceInput.submitConfirm.ok': '确认并提交',
  'pages.attendanceInput.submitConfirm.cancel': '返回检查',
  'pages.development.learnManagement.progress.evaluation.title': '评价',
  'pages.development.learnManagement.progress.evaluation.empty': '未填写',
  'pages.development.learnManagement.progress.evaluation.edit': '编辑评价',
  'pages.development.learnManagement.progress.evaluation.save': '保存',
  'pages.development.learnManagement.progress.evaluation.cancel': '取消',
  'pages.development.learnManagement.progress.evaluation.placeholder': '请输入评价（最多100字）',
  'pages.development.learnManagement.progress.evaluation.saved': '评价已保存。',
  'pages.development.learnManagement.progress.evaluation.saveFailed':
    '评价保存失败，请检查输入内容后重试。',
  'pages.development.learnManagement.progress.evaluation.tooLong':
    '评价最多100字，已有内容不会被自动截断。',
};
